import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
};

export type Access = {
  __typename?: 'Access';
  accessToken?: Maybe<TokenData>;
};

export type AccessInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
};

export type AddAddressInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  govNO?: InputMaybe<Scalars['String']['input']>;
  govOffName?: InputMaybe<Scalars['String']['input']>;
  govOfficialCheo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  kata?: InputMaybe<Scalars['String']['input']>;
  mtaa?: InputMaybe<Scalars['String']['input']>;
  nyumbaNo?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  wilaya?: InputMaybe<Scalars['String']['input']>;
};

export type AddCartInput = {
  bandaAndAreaItems?: InputMaybe<Array<InputMaybe<CartItems>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  feedBackId?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  isPromo?: InputMaybe<Scalars['Boolean']['input']>;
  isReserved?: InputMaybe<Scalars['Boolean']['input']>;
  itemName?: InputMaybe<Scalars['String']['input']>;
  mainCartId?: InputMaybe<Scalars['String']['input']>;
  orderSteps?: InputMaybe<Scalars['String']['input']>;
  promoId?: InputMaybe<Scalars['String']['input']>;
  sponsorId?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AddCheckedInput = {
  checkId?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AddFavInput = {
  images?: InputMaybe<Scalars['String']['input']>;
  likeId?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AddPoliceUrlInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AddWadhaminiInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  govOfficialCheo1?: InputMaybe<Scalars['String']['input']>;
  govOfficialCheo2?: InputMaybe<Scalars['String']['input']>;
  govPhone1?: InputMaybe<Scalars['String']['input']>;
  govPhone2?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name1?: InputMaybe<Scalars['String']['input']>;
  name2?: InputMaybe<Scalars['String']['input']>;
  nida1?: InputMaybe<Scalars['String']['input']>;
  nida2?: InputMaybe<Scalars['String']['input']>;
  phone1?: InputMaybe<Scalars['String']['input']>;
  phone2?: InputMaybe<Scalars['String']['input']>;
};

export type Agenda = {
  __typename?: 'Agenda';
  author?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfEvent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  published?: Maybe<Scalars['Boolean']['output']>;
  statement?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trackerCount?: Maybe<Scalars['String']['output']>;
};

export type AgendaLight = {
  __typename?: 'AgendaLight';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfEvent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  published?: Maybe<Scalars['Boolean']['output']>;
  statement?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trackerCount?: Maybe<Scalars['String']['output']>;
};

export type AgendaPosts = {
  __typename?: 'AgendaPosts';
  author?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfEvent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  posts?: Maybe<Array<Maybe<Post>>>;
  published?: Maybe<Scalars['Boolean']['output']>;
  statement?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trackerCount?: Maybe<Scalars['String']['output']>;
};

export type AgendaResponse = {
  __typename?: 'AgendaResponse';
  postsFetched?: Maybe<Array<Maybe<Agenda>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AreaData = {
  __typename?: 'AreaData';
  areaName?: Maybe<Scalars['String']['output']>;
  areaType?: Maybe<Scalars['String']['output']>;
  banda?: Maybe<Array<Maybe<Banda>>>;
  bandaNumber?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  districtName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  wardName?: Maybe<Scalars['String']['output']>;
};

export type Auth = {
  __typename?: 'Auth';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type AuthLogin = {
  __typename?: 'AuthLogin';
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type AuthLoginReg = {
  inputData: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AutoLoginMobileInput = {
  inputData: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type Banda = {
  __typename?: 'Banda';
  address?: Maybe<Scalars['String']['output']>;
  addsPromo?: Maybe<Array<Maybe<PromoEvent>>>;
  airConditioner?: Maybe<Scalars['Boolean']['output']>;
  bandaCode?: Maybe<Scalars['String']['output']>;
  bandaName?: Maybe<Scalars['String']['output']>;
  bandaPassword?: Maybe<Scalars['String']['output']>;
  bandaSize?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  decoders?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  drinks?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  eventsFunds?: Maybe<Array<Maybe<Event>>>;
  feni?: Maybe<Scalars['Boolean']['output']>;
  food?: Maybe<Scalars['Boolean']['output']>;
  gallery?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  generator?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  laptop?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Scalars['String']['output']>;
  mtaa?: Maybe<Mtaa>;
  mtaaId?: Maybe<Scalars['String']['output']>;
  mtaaName?: Maybe<Scalars['String']['output']>;
  nafasiWazi?: Maybe<Scalars['Boolean']['output']>;
  numberOfTv?: Maybe<Scalars['Int']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  physicalResidency?: Maybe<Scalars['String']['output']>;
  priceHour?: Maybe<Scalars['Float']['output']>;
  projector?: Maybe<Scalars['Boolean']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionData?: Maybe<Mtaa>;
  tvSize?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userNationalId?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  vikalioKutoka?: Maybe<Scalars['Boolean']['output']>;
  ward?: Maybe<Scalars['String']['output']>;
  wifi?: Maybe<Scalars['Boolean']['output']>;
};

export type BandaListData = {
  __typename?: 'BandaListData';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type BandaListFilterInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  ageRestriction?: InputMaybe<Scalars['String']['input']>;
  airConditioner?: InputMaybe<Scalars['Boolean']['input']>;
  bandaCode?: InputMaybe<Scalars['String']['input']>;
  bandaName?: InputMaybe<Scalars['String']['input']>;
  bandaPassword?: InputMaybe<Scalars['String']['input']>;
  bandaSize?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closingTime?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  decoders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  district?: InputMaybe<Scalars['String']['input']>;
  drinks?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feni?: InputMaybe<Scalars['Boolean']['input']>;
  food?: InputMaybe<Scalars['Boolean']['input']>;
  generator?: InputMaybe<Scalars['Boolean']['input']>;
  laptop?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  nafasiWazi?: InputMaybe<Scalars['Boolean']['input']>;
  nationalID?: InputMaybe<Scalars['String']['input']>;
  numberOfTv?: InputMaybe<Scalars['Int']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  physicalResidency?: InputMaybe<Scalars['String']['input']>;
  priceHour?: InputMaybe<Scalars['Float']['input']>;
  projector?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  tvSize?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeOfSeats?: InputMaybe<Scalars['String']['input']>;
  umeme?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  vikalioKutoka?: InputMaybe<Scalars['Boolean']['input']>;
  ward?: InputMaybe<Scalars['String']['input']>;
  wifi?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BandaManageI = {
  __typename?: 'BandaManageI';
  address?: Maybe<Scalars['String']['output']>;
  addsPromo?: Maybe<Array<Maybe<PromoEvent>>>;
  airConditioner?: Maybe<Scalars['Boolean']['output']>;
  bandaCode?: Maybe<Scalars['String']['output']>;
  bandaName?: Maybe<Scalars['String']['output']>;
  bandaPassword?: Maybe<Scalars['String']['output']>;
  bandaSize?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  closingTime?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  decoders?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  drinks?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  eventsFunds?: Maybe<Array<Maybe<Event>>>;
  feni?: Maybe<Scalars['Boolean']['output']>;
  food?: Maybe<Scalars['Boolean']['output']>;
  gallery?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  generator?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  laptop?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Scalars['String']['output']>;
  nafasiWazi?: Maybe<Scalars['Boolean']['output']>;
  numberOfTv?: Maybe<Scalars['Int']['output']>;
  openingTime?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  physicalResidency?: Maybe<Scalars['String']['output']>;
  priceHour?: Maybe<Scalars['Float']['output']>;
  projector?: Maybe<Scalars['Boolean']['output']>;
  tvSize?: Maybe<Scalars['String']['output']>;
  typeOfSeats?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userNationalId?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  wifi?: Maybe<Scalars['Boolean']['output']>;
};

export type BandaPage = {
  __typename?: 'BandaPage';
  count?: Maybe<Scalars['Int']['output']>;
  list?: Maybe<Array<Maybe<Banda>>>;
};

export type BandaWorkingHoursInput = {
  bandaId?: InputMaybe<Scalars['String']['input']>;
  closingTime?: InputMaybe<Scalars['String']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
};

export type BucketFund = {
  __typename?: 'BucketFund';
  amount?: Maybe<Scalars['Float']['output']>;
  cartItemId?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Content>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  eventType: EventType;
  frequency?: Maybe<Scalars['Int']['output']>;
  fundType: BucketFundType;
  id?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  orderSteps?: Maybe<OrderSteps>;
  orderType?: Maybe<OrderType>;
  paymentId?: Maybe<Scalars['String']['output']>;
  promoId?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  specifiedArea?: Maybe<Scalars['String']['output']>;
  sponsor?: Maybe<Sponsor>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  uniqueContraint?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  ward?: Maybe<Scalars['String']['output']>;
};

export enum BucketFundType {
  Any = 'ANY',
  HasContent = 'HAS_CONTENT'
}

export type CartItem = {
  __typename?: 'CartItem';
  activated?: Maybe<Scalars['Boolean']['output']>;
  billingSource?: Maybe<Scalars['String']['output']>;
  bucketFund?: Maybe<Array<Maybe<BucketFund>>>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Maybe<Event>>>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  isPromo?: Maybe<Scalars['Boolean']['output']>;
  itemName?: Maybe<Scalars['String']['output']>;
  orderSteps?: Maybe<OrderSteps>;
  orders?: Maybe<Array<Maybe<PaymentOrder>>>;
  promoBucket?: Maybe<Array<Maybe<PromoBucket>>>;
  promoEvents?: Maybe<Array<Maybe<PromoEvent>>>;
  promoId?: Maybe<Scalars['String']['output']>;
  sponsor?: Maybe<Sponsor>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CartItems = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  contentHostingPromoId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dates?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  isPromoted?: InputMaybe<Scalars['Boolean']['input']>;
  mainCartId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sponsorId?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  ward?: InputMaybe<Scalars['String']['input']>;
};

export type CartItemsType = {
  __typename?: 'CartItemsType';
  areaCode?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type CartOrderInput = {
  sponsorId: Scalars['String']['input'];
};

export type Categories = {
  __typename?: 'Categories';
  name?: Maybe<Scalars['String']['output']>;
};

export type ChangePasswordAuthInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type ChangePasswordInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type ChangePasswordRequestInput = {
  inputData?: InputMaybe<Scalars['String']['input']>;
};

export type ChangePasswordRequestType = {
  __typename?: 'ChangePasswordRequestType';
  log: Scalars['Boolean']['output'];
  msg: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ChangePasswordType = {
  __typename?: 'ChangePasswordType';
  log: Scalars['Boolean']['output'];
};

export type ConfirmedResponse = {
  __typename?: 'ConfirmedResponse';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type Content = {
  __typename?: 'Content';
  amount?: Maybe<Scalars['Float']['output']>;
  author?: Maybe<UserDataForList>;
  bucketFunds?: Maybe<Array<Maybe<BucketFund>>>;
  categories?: Maybe<Array<Maybe<Categories>>>;
  count?: Maybe<Scalars['Int']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endDateTime?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Maybe<Event>>>;
  fundedBy?: Maybe<Scalars['Int']['output']>;
  gallery?: Maybe<Array<Maybe<Gallery>>>;
  id?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Scalars['String']['output']>;
};

export type ContentOwnersPage = {
  __typename?: 'ContentOwnersPage';
  count?: Maybe<Scalars['Int']['output']>;
  list?: Maybe<Array<Maybe<UseristI>>>;
};

export type ContentPage = {
  __typename?: 'ContentPage';
  count?: Maybe<Scalars['Int']['output']>;
  list?: Maybe<Array<Maybe<Content>>>;
};

export enum ContentType {
  Normal = 'NORMAL',
  Promo = 'PROMO',
  Scheduled = 'SCHEDULED'
}

export type Counted = {
  __typename?: 'Counted';
  count?: Maybe<Scalars['Int']['output']>;
};

export type CreateAuthInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateClientData = {
  __typename?: 'CreateClientData';
  log: Scalars['Boolean']['output'];
  msg: Scalars['String']['output'];
  status: PartnerShipSteps;
};

export type CreateClientInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  chargedFor?: InputMaybe<PaymentFor>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  nambaNida?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<SubPlan>;
  planFrequency?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateContentInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  categorySelected?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  verifiedBy?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEventInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  bandaId?: InputMaybe<Scalars['String']['input']>;
  breakDurationInMins?: InputMaybe<Scalars['Int']['input']>;
  breakFrequency?: InputMaybe<Scalars['Int']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDateTime: Scalars['String']['input'];
  eventIdForPromo?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  promoId?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorId?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderInput = {
  OrderType?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  bandaId?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  cartItemId?: InputMaybe<Scalars['String']['input']>;
  confirmationNumber?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  controlNumber?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  mainCartId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payDate?: InputMaybe<Scalars['String']['input']>;
  payerName?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentSource?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  promoId?: InputMaybe<Scalars['String']['input']>;
  remainingAmount?: InputMaybe<Scalars['Float']['input']>;
  sponsorId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardOutput = {
  __typename?: 'DashboardOutput';
  adds?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  banda?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  people?: Maybe<Scalars['Int']['output']>;
  reservations?: Maybe<Scalars['Int']['output']>;
};

export type DeleteEvent = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type District = {
  __typename?: 'District';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  regionData?: Maybe<Region>;
  regionId?: Maybe<Scalars['String']['output']>;
  wards?: Maybe<Array<Maybe<Ward>>>;
};

export type DoneConfirmation = {
  __typename?: 'DoneConfirmation';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type EditBandaInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  airConditioner?: InputMaybe<Scalars['Boolean']['input']>;
  bandaName?: InputMaybe<Scalars['String']['input']>;
  bandaPassword?: InputMaybe<Scalars['String']['input']>;
  bandaSize?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  closingTime?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  decoders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  districtPostcode?: InputMaybe<Scalars['String']['input']>;
  drinks?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feni?: InputMaybe<Scalars['Boolean']['input']>;
  food?: InputMaybe<Scalars['Boolean']['input']>;
  generator?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
  laptop?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mtaaId?: InputMaybe<Scalars['String']['input']>;
  mtaaName?: InputMaybe<Scalars['String']['input']>;
  nafasiWazi?: InputMaybe<Scalars['Boolean']['input']>;
  nationalID?: InputMaybe<Scalars['String']['input']>;
  numberOfTv?: InputMaybe<Scalars['Int']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  physicalResidency?: InputMaybe<Scalars['String']['input']>;
  priceHour?: InputMaybe<Scalars['Float']['input']>;
  projector?: InputMaybe<Scalars['Boolean']['input']>;
  tvSize?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeOfSeats?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  wardPostcode?: InputMaybe<Scalars['String']['input']>;
  wifi?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EditContentInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  categorySelected?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  verifiedBy?: InputMaybe<Scalars['String']['input']>;
};

export type EditContentOwnerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isCompany?: InputMaybe<Scalars['Boolean']['input']>;
  mtaa?: InputMaybe<Scalars['String']['input']>;
  nationalID?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  physicalResidency?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  ward?: InputMaybe<Scalars['String']['input']>;
};

export type EditSponsorInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  companyID?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contentOwnership?: InputMaybe<Scalars['Boolean']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isCompany?: InputMaybe<Scalars['Boolean']['input']>;
  mtaa?: InputMaybe<Scalars['String']['input']>;
  nationalID?: InputMaybe<Scalars['String']['input']>;
  organisationDoc?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  physicalResidency?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  socialLinks?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  usernameSponsor?: InputMaybe<Scalars['String']['input']>;
  ward?: InputMaybe<Scalars['String']['input']>;
};

export type EmailToken = {
  __typename?: 'EmailToken';
  emailToken?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  __typename?: 'Event';
  amount?: Maybe<Scalars['Float']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  banda?: Maybe<Banda>;
  bandaCode?: Maybe<Scalars['String']['output']>;
  bandaId?: Maybe<Scalars['String']['output']>;
  breakDurationInMins?: Maybe<Scalars['Int']['output']>;
  breakFrequency?: Maybe<Scalars['Int']['output']>;
  cartItemId?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Content>;
  contentId?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['String']['output']>;
  eventIdForPromo?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<EventType>;
  frequency?: Maybe<Scalars['Int']['output']>;
  fundedBy?: Maybe<Scalars['String']['output']>;
  gallery?: Maybe<Array<Maybe<Gallery>>>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  orderSteps?: Maybe<OrderSteps>;
  orderType?: Maybe<OrderType>;
  promoId?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  scheduleData?: Maybe<Scalars['String']['output']>;
  sponsor?: Maybe<Sponsor>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type EventDataInterface = {
  __typename?: 'EventDataInterface';
  amount?: Maybe<Scalars['Float']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  banda?: Maybe<Banda>;
  bandaCode?: Maybe<Scalars['String']['output']>;
  bandaId?: Maybe<Scalars['String']['output']>;
  breakDurationInMins?: Maybe<Scalars['Int']['output']>;
  breakFrequency?: Maybe<Scalars['Int']['output']>;
  cartItemId?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Content>;
  contentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['String']['output']>;
  eventIdForPromo?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<EventType>;
  frequency?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  orderSteps?: Maybe<OrderSteps>;
  orderType?: Maybe<OrderType>;
  promoId?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  scheduleData?: Maybe<Scalars['String']['output']>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum EventType {
  Basic = 'BASIC',
  Funded = 'FUNDED',
  Private = 'PRIVATE',
  Promo = 'PROMO'
}

export type FeedInputData = {
  category: Scalars['String']['input'];
  contentId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type FeedInputDataCodeManage = {
  category: Scalars['String']['input'];
  contentId?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  ward?: InputMaybe<Scalars['String']['input']>;
};

export type FeedInputPromoData = {
  category: Scalars['String']['input'];
  contentId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type FeedResponse = {
  __typename?: 'FeedResponse';
  postsFetched?: Maybe<Array<Maybe<Post>>>;
};

export type FindBandaumizaInput = {
  bandaId: Scalars['String']['input'];
};

export type Gallery = {
  __typename?: 'Gallery';
  authorSponsor?: Maybe<Sponsor>;
  bandaId?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Content>;
  contentId?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  published?: Maybe<Scalars['Boolean']['output']>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GalleryInput = {
  bandaId?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetAgendaData = {
  agendaId?: InputMaybe<Scalars['String']['input']>;
};

export type GetContentInput = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GetContentsInput = {
  category: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sponsoredMode?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetEventInput = {
  eventId?: InputMaybe<Scalars['String']['input']>;
};

export type GetEventsInput = {
  category: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetMyBandaEventsInput = {
  bandaId?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GetMyBandaInput = {
  bandaId?: InputMaybe<Scalars['String']['input']>;
};

export type GetMyContentInput = {
  category: Scalars['String']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetSponsorProfileInput = {
  filterData?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};

export type GetSponsorsInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetSportsInput = {
  bandaId?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  competition?: InputMaybe<Scalars['String']['input']>;
  matchTitle?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
};

export type GetTopic = {
  postId: Scalars['String']['input'];
};

export type GetTopicInAgendaData = {
  agendaId: Scalars['String']['input'];
};

export type GetUserProfileInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type IAddTopicInAgenda = {
  agendaId?: InputMaybe<Scalars['String']['input']>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  categorySelected?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  statement?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagsPosts>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicId?: InputMaybe<Scalars['String']['input']>;
};

export type IContentUploaded = {
  __typename?: 'IContentUploaded';
  id: Scalars['String']['output'];
};

export type IDeleteAgenda = {
  agendaId?: InputMaybe<Scalars['String']['input']>;
};

export type IDeleteTopicInAgenda = {
  topicId?: InputMaybe<Scalars['String']['input']>;
};

export type ImageInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type IntBanda = {
  __typename?: 'IntBanda';
  id: Scalars['String']['output'];
};

export type Jembe = {
  __typename?: 'Jembe';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Maybe<Event>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  manageKey?: Maybe<Scalars['String']['output']>;
  middlename?: Maybe<Scalars['String']['output']>;
  mtaa?: Maybe<Scalars['String']['output']>;
  mtaaId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  physicalResidency?: Maybe<Scalars['String']['output']>;
  promoEvents?: Maybe<Array<Maybe<PromoEvent>>>;
  region?: Maybe<Scalars['String']['output']>;
  regionData?: Maybe<Mtaa>;
  userNationalId?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Scalars['String']['output']>;
  ward?: Maybe<Scalars['String']['output']>;
};

export type LData = {
  __typename?: 'LData';
  data: Scalars['String']['output'];
};

export type LogoutAuthInput = {
  id: Scalars['String']['input'];
};

export type LogoutData = {
  __typename?: 'LogoutData';
  log: Scalars['Boolean']['output'];
  msg?: Maybe<Scalars['String']['output']>;
  tokenVersion: Scalars['String']['output'];
};

export type LogoutInput = {
  id: Scalars['String']['input'];
};

export type MainCart = {
  __typename?: 'MainCart';
  activated?: Maybe<Scalars['Boolean']['output']>;
  billingSource?: Maybe<Scalars['String']['output']>;
  carts?: Maybe<Array<Maybe<CartItem>>>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  orderSteps?: Maybe<OrderSteps>;
  sponsor?: Maybe<Sponsor>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ManageEditBandaDataInputs = {
  id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  regData?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ManageEditContentDataInputs = {
  id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  regData?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ManageEditSponsorDataInputs = {
  id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  regData?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ManageEditUserDataInputs = {
  id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  regData?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ManageInputValue = {
  id: Scalars['String']['input'];
  managerId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type Manager = {
  __typename?: 'Manager';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expireAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  physicalResidency?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userNationalId?: Maybe<Scalars['String']['output']>;
};

export type Mtaa = {
  __typename?: 'Mtaa';
  Attachments?: Maybe<Scalars['String']['output']>;
  Details?: Maybe<Scalars['String']['output']>;
  Men?: Maybe<Scalars['String']['output']>;
  Population?: Maybe<Scalars['String']['output']>;
  Vijana?: Maybe<Scalars['String']['output']>;
  Watoto?: Maybe<Scalars['String']['output']>;
  Women?: Maybe<Scalars['String']['output']>;
  banda?: Maybe<Array<Maybe<Banda>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  jembe?: Maybe<Array<Maybe<Jembe>>>;
  kaya?: Maybe<Scalars['String']['output']>;
  matukio?: Maybe<Array<Maybe<Event>>>;
  mawasilianoMwenyekiti?: Maybe<Scalars['String']['output']>;
  mwenyekiti?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameWardCode?: Maybe<Scalars['String']['output']>;
  regionData?: Maybe<RegionData>;
  regionId?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
  wananchi?: Maybe<Array<Maybe<Mwananchi>>>;
  ward?: Maybe<Ward>;
  wardId?: Maybe<Scalars['String']['output']>;
  wardPostCode?: Maybe<Scalars['String']['output']>;
  watendaji?: Maybe<Scalars['String']['output']>;
  wazee?: Maybe<Scalars['String']['output']>;
};

export type MtaaInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['String']['input']>;
  wardId?: InputMaybe<Scalars['String']['input']>;
  wardPostCode?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAddress: VerifyReturnType;
  addBandaGalleryImage: ConfirmedResponse;
  addBandaProfileImage: ConfirmedResponse;
  addCart?: Maybe<Response>;
  addCartSponsor?: Maybe<Response>;
  addCheckedPosts?: Maybe<Response>;
  addCoverImage: ConfirmedResponse;
  addFav?: Maybe<Response>;
  addPoliceUrl: VerifyReturnType;
  addSponsorGalleryImage: ConfirmedResponse;
  addSponsorSocialLinks: RegistrationData;
  addSuperAdmin: TokenDataMobile;
  addTopicToAgenda: ConfirmedResponse;
  addUserProfileImage: ConfirmedResponse;
  addWadhamini: VerifyReturnType;
  autoLoginMobile: TokenDataMobile;
  blockBanda: RegistrationData;
  blockContentOwner: RegistrationData;
  blockSponsor: RegistrationData;
  changePasswordRequest: ChangePasswordRequestType;
  changepassword: ChangePasswordType;
  confirmOrder: DoneConfirmation;
  createAgenda: ConfirmedResponse;
  createAgendaAndPost: ConfirmedResponse;
  createClient: CreateClientData;
  createContent: ConfirmedResponse;
  createEvent: ConfirmedResponse;
  createOrder: DoneConfirmation;
  createSub: CreateClientData;
  deleteAgenda: ConfirmedResponse;
  deleteManager: RegistrationData;
  deleteSponsorGalleryImage: ConfirmedResponse;
  deleteTopicInAgenda: ConfirmedResponse;
  disableContent: ConfirmedResponse;
  disableEvents: ConfirmedResponse;
  editContent: ConfirmedResponse;
  editSponsorData: RegistrationData;
  establishInvoice: DoneConfirmation;
  getLevel: ChangePasswordType;
  login: TokenData;
  loginBanda: TokenDataMobile;
  loginManage: TokenDataMobile;
  loginMobile: TokenDataMobile;
  logout: LogoutData;
  logoutMobile: LogoutData;
  manageEditUser: RegistrationData;
  registerManager: RegistrationData;
  registration: RegistrationData;
  registrationBanda: RegistrationSponsorData;
  registrationContentOwner: RegistrationSponsorData;
  registrationSponsor: RegistrationSponsorData;
  removeBandaGalleryImage: ConfirmedResponse;
  removeContent: ConfirmedResponse;
  removeEvent: ConfirmedResponse;
  removeFav?: Maybe<Response>;
  removeSponsorGalleryImage: ConfirmedResponse;
  renewPasswordRequest: ChangePasswordRequestType;
  renewpassword: ChangePasswordType;
  silentLogin: VerifyTokenType;
  suspensionManager: RegistrationData;
  updateBanda: RegistrationData;
  updateBandaWorkingHours: RegistrationData;
  updateContentOwner: RegistrationData;
  updateOrder: DoneConfirmation;
  updateSponsor: RegistrationData;
  verifyBanda: RegistrationData;
  verifyContentOwner: RegistrationData;
  verifyEmail: VerifyTokenType;
  verifyEmailRequest: ChangePasswordRequestType;
  verifyNida: VerifyReturnType;
  verifyPhoneRequest: ChangePasswordRequestType;
  verifySentCode: VerifyTokenType;
  verifySponsor: RegistrationData;
  verifyTokenService: VerifyTokenType;
};


export type MutationAddAddressArgs = {
  addAddressInput: AddAddressInput;
};


export type MutationAddBandaGalleryImageArgs = {
  imageInput: ImageInput;
};


export type MutationAddBandaProfileImageArgs = {
  imageInput: ImageInput;
};


export type MutationAddCartArgs = {
  addCartInput: AddCartInput;
};


export type MutationAddCartSponsorArgs = {
  addCartInput: AddCartInput;
};


export type MutationAddCheckedPostsArgs = {
  addCheckedInput: AddCheckedInput;
};


export type MutationAddCoverImageArgs = {
  imageInput: ImageInput;
};


export type MutationAddFavArgs = {
  addFavInput: AddFavInput;
};


export type MutationAddPoliceUrlArgs = {
  addPoliceUrlInput: AddPoliceUrlInput;
};


export type MutationAddSponsorGalleryImageArgs = {
  galleryInput: GalleryInput;
};


export type MutationAddSponsorSocialLinksArgs = {
  editSponsorInput?: InputMaybe<EditSponsorInput>;
};


export type MutationAddSuperAdminArgs = {
  authLoginReg: AuthLoginReg;
};


export type MutationAddTopicToAgendaArgs = {
  addTopicInAgenda: IAddTopicInAgenda;
};


export type MutationAddUserProfileImageArgs = {
  imageInput: ImageInput;
};


export type MutationAddWadhaminiArgs = {
  addWadhaminiInput: AddWadhaminiInput;
};


export type MutationAutoLoginMobileArgs = {
  autoLoginMobileInput: AutoLoginMobileInput;
};


export type MutationBlockBandaArgs = {
  verifySponsorInput?: InputMaybe<VerifySponsorInput>;
};


export type MutationBlockContentOwnerArgs = {
  verifyContentInput?: InputMaybe<VerifyContentOwnerInput>;
};


export type MutationBlockSponsorArgs = {
  verifySponsorInput?: InputMaybe<VerifySponsorInput>;
};


export type MutationChangePasswordRequestArgs = {
  changePasswordRequestInput?: InputMaybe<ChangePasswordRequestInput>;
};


export type MutationChangepasswordArgs = {
  changePasswordInput: ChangePasswordInput;
};


export type MutationConfirmOrderArgs = {
  createOrderInput: CreateOrderInput;
};


export type MutationCreateAgendaArgs = {
  createPostInput: PostInput;
};


export type MutationCreateAgendaAndPostArgs = {
  createPostInput: PostInput;
};


export type MutationCreateClientArgs = {
  createClientInput: CreateClientInput;
};


export type MutationCreateContentArgs = {
  createContentInput: CreateContentInput;
};


export type MutationCreateEventArgs = {
  createEventInput: CreateEventInput;
};


export type MutationCreateOrderArgs = {
  createOrderInput: CreateOrderInput;
};


export type MutationCreateSubArgs = {
  subInput: SubInput;
};


export type MutationDeleteAgendaArgs = {
  iDeleteAgenda: IDeleteAgenda;
};


export type MutationDeleteManagerArgs = {
  manageInputValue: ManageInputValue;
};


export type MutationDeleteSponsorGalleryImageArgs = {
  imageInput: ImageInput;
};


export type MutationDeleteTopicInAgendaArgs = {
  iDeleteTopicInAgenda: IDeleteTopicInAgenda;
};


export type MutationDisableContentArgs = {
  deleteEvent: DeleteEvent;
};


export type MutationDisableEventsArgs = {
  deleteEvent: DeleteEvent;
};


export type MutationEditContentArgs = {
  editContentInput: EditContentInput;
};


export type MutationEditSponsorDataArgs = {
  editSponsorInput?: InputMaybe<EditSponsorInput>;
};


export type MutationEstablishInvoiceArgs = {
  createOrderInput: CreateOrderInput;
};


export type MutationGetLevelArgs = {
  changePasswordInput: ChangePasswordInput;
};


export type MutationLoginArgs = {
  authLoginReg: AuthLoginReg;
};


export type MutationLoginBandaArgs = {
  authLoginReg: AuthLoginReg;
};


export type MutationLoginManageArgs = {
  authLoginReg: AuthLoginReg;
};


export type MutationLoginMobileArgs = {
  authLoginReg: AuthLoginReg;
};


export type MutationLogoutArgs = {
  logoutAuthInput?: InputMaybe<LogoutAuthInput>;
};


export type MutationLogoutMobileArgs = {
  logoutAuthInput?: InputMaybe<LogoutAuthInput>;
};


export type MutationManageEditUserArgs = {
  manageEditBandaDataInputs: ManageEditBandaDataInputs;
};


export type MutationRegisterManagerArgs = {
  registerManagerInput: RegisterManagerInput;
};


export type MutationRegistrationArgs = {
  registerInput: RegisterInput;
};


export type MutationRegistrationBandaArgs = {
  registerBandaInput: RegisterBandaInput;
};


export type MutationRegistrationContentOwnerArgs = {
  registerContentInput: RegisterContentInput;
};


export type MutationRegistrationSponsorArgs = {
  registerSponsorInput: RegisterSponsorInput;
};


export type MutationRemoveBandaGalleryImageArgs = {
  imageInput: ImageInput;
};


export type MutationRemoveContentArgs = {
  deleteEvent: DeleteEvent;
};


export type MutationRemoveEventArgs = {
  deleteEvent: DeleteEvent;
};


export type MutationRemoveFavArgs = {
  addFavInput: AddFavInput;
};


export type MutationRemoveSponsorGalleryImageArgs = {
  imageInput: ImageInput;
};


export type MutationRenewPasswordRequestArgs = {
  renewPasswordRequestInput?: InputMaybe<RenewPasswordRequestInput>;
};


export type MutationRenewpasswordArgs = {
  changePasswordInput: ChangePasswordInput;
};


export type MutationSilentLoginArgs = {
  accessInput: AccessInput;
};


export type MutationSuspensionManagerArgs = {
  manageInputValue: ManageInputValue;
};


export type MutationUpdateBandaArgs = {
  editBandaInput?: InputMaybe<EditBandaInput>;
};


export type MutationUpdateBandaWorkingHoursArgs = {
  bandaWorkingHoursInput: BandaWorkingHoursInput;
};


export type MutationUpdateContentOwnerArgs = {
  editContentOwnerInput?: InputMaybe<EditContentOwnerInput>;
};


export type MutationUpdateOrderArgs = {
  createOrderInput: CreateOrderInput;
};


export type MutationUpdateSponsorArgs = {
  editSponsorInput?: InputMaybe<EditSponsorInput>;
};


export type MutationVerifyBandaArgs = {
  verifySponsorInput?: InputMaybe<VerifySponsorInput>;
};


export type MutationVerifyContentOwnerArgs = {
  verifyContentOwnerInput?: InputMaybe<VerifyContentOwnerInput>;
};


export type MutationVerifyEmailArgs = {
  verifyTokenService?: InputMaybe<VerifyTokenService>;
};


export type MutationVerifyEmailRequestArgs = {
  verifyEmailRequestInput?: InputMaybe<VerifyEmailRequestInput>;
};


export type MutationVerifyNidaArgs = {
  verifyNidaInput: VerifyNidaInput;
};


export type MutationVerifyPhoneRequestArgs = {
  verifyPhoneRequestInput: VerifyPhoneRequestInput;
};


export type MutationVerifySentCodeArgs = {
  verifyCodeService: VerifyCodeService;
};


export type MutationVerifySponsorArgs = {
  verifySponsorInput?: InputMaybe<VerifySponsorInput>;
};


export type MutationVerifyTokenServiceArgs = {
  verifyTokenService?: InputMaybe<VerifyTokenService>;
};

export type Mwananchi = {
  __typename?: 'Mwananchi';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Maybe<Event>>>;
  id?: Maybe<Scalars['String']['output']>;
  mtaa?: Maybe<Mtaa>;
  mtaaId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  wardPostCode?: Maybe<Scalars['String']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSeen?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Scalars['String']['output']>;
  notificationType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum OrderSteps {
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Invoice = 'INVOICE',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  Success = 'SUCCESS'
}

export enum OrderType {
  Banda = 'BANDA',
  Bucket = 'BUCKET',
  PromoBanda = 'PROMO_BANDA',
  PromoBucket = 'PROMO_BUCKET'
}

export type OrdersInput = {
  OrderType?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  bandaId?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  confirmationNumber?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  controlNumber?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  payDate?: InputMaybe<Scalars['String']['input']>;
  payerName?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentSource?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  promoId?: InputMaybe<Scalars['String']['input']>;
  remainingAmount?: InputMaybe<Scalars['Float']['input']>;
  sponsorId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum PartnerShipSteps {
  AllSubmited = 'ALL_SUBMITED',
  None = 'NONE',
  PhoneVerified = 'PHONE_VERIFIED',
  Register = 'REGISTER',
  SubmitedNida = 'SUBMITED_NIDA',
  SubmitedPhone = 'SUBMITED_PHONE',
  SubmitedPolice = 'SUBMITED_POLICE',
  WadhaminiAddress = 'WADHAMINI_ADDRESS',
  WadhaminiPolice = 'WADHAMINI_POLICE'
}

export type PartnershipProfile = {
  __typename?: 'PartnershipProfile';
  addedAddress?: Maybe<Scalars['Boolean']['output']>;
  addedWadhamini?: Maybe<Scalars['Boolean']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isClientAppStatus?: Maybe<Scalars['String']['output']>;
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  nidaVerified?: Maybe<Scalars['Boolean']['output']>;
  phoneNoVerified?: Maybe<Scalars['Boolean']['output']>;
  policeClearanced?: Maybe<Scalars['Boolean']['output']>;
  status: PartnerShipSteps;
  username?: Maybe<Scalars['String']['output']>;
  waitingForCode?: Maybe<Scalars['Boolean']['output']>;
};

export enum PaymentFor {
  JoiningFee = 'JOINING_FEE',
  None = 'NONE',
  Post = 'POST',
  Subscription = 'SUBSCRIPTION'
}

export type PaymentOrder = {
  __typename?: 'PaymentOrder';
  OrderType?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  bandaId?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Scalars['String']['output']>;
  cartItemId?: Maybe<Scalars['String']['output']>;
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  controlNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  payDate?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentSource?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  promoId?: Maybe<Scalars['String']['output']>;
  remainingAmount?: Maybe<Scalars['Float']['output']>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Post = {
  __typename?: 'Post';
  authorId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfEvent?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  published?: Maybe<Scalars['Boolean']['output']>;
  statement?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type PostInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  categorySelected?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  statement?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagsPosts>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type PromoBucket = {
  __typename?: 'PromoBucket';
  AddName?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  cartItemId?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  fundType: BucketFundType;
  id?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  orderSteps?: Maybe<OrderSteps>;
  orderType?: Maybe<OrderType>;
  paymentId?: Maybe<Scalars['String']['output']>;
  promoId?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  specifiedArea?: Maybe<Scalars['String']['output']>;
  sponsor?: Maybe<Sponsor>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  uniqueContraint?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  ward?: Maybe<Scalars['String']['output']>;
};

export type PromoEvent = {
  __typename?: 'PromoEvent';
  amount?: Maybe<Scalars['Float']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  banda?: Maybe<Banda>;
  bandaCode?: Maybe<Scalars['String']['output']>;
  bandaId?: Maybe<Scalars['String']['output']>;
  breakDurationInMins?: Maybe<Scalars['Int']['output']>;
  breakFrequency?: Maybe<Scalars['Int']['output']>;
  cartItemId?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDateTime: Scalars['DateTime']['output'];
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['String']['output']>;
  eventIdForPromo?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<EventType>;
  eventUniqueInstance?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  matchId?: Maybe<Scalars['String']['output']>;
  orderSteps?: Maybe<OrderSteps>;
  orderType?: Maybe<OrderType>;
  paymentId?: Maybe<Scalars['String']['output']>;
  promoId?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  startDateTime: Scalars['DateTime']['output'];
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  aTopic?: Maybe<Post>;
  agendaList?: Maybe<AgendaResponse>;
  agendaListSearch?: Maybe<Array<Maybe<Agenda>>>;
  agendaTopicsList?: Maybe<AgendaPosts>;
  allOrders?: Maybe<Array<Maybe<PaymentOrder>>>;
  allOrdersInCart?: Maybe<Array<Maybe<CartItem>>>;
  bandaList?: Maybe<Array<Maybe<Banda>>>;
  bandaListFilter?: Maybe<BandaPage>;
  checkSportsList?: Maybe<Array<Maybe<Content>>>;
  contentList?: Maybe<ContentPage>;
  contentListCount?: Maybe<Counted>;
  contentListManage?: Maybe<Array<Maybe<Content>>>;
  contentOwner?: Maybe<UserProfile>;
  contentOwnersList?: Maybe<ContentOwnersPage>;
  eventsList?: Maybe<Array<Maybe<Event>>>;
  feed?: Maybe<FeedResponse>;
  filterAreas?: Maybe<Array<Maybe<AreaData>>>;
  getBanda?: Maybe<Banda>;
  getBandaByCode?: Maybe<Array<Maybe<Banda>>>;
  getBandaByCodePromo?: Maybe<Array<Maybe<Banda>>>;
  getBandaFunded?: Maybe<Array<Maybe<Event>>>;
  getBandaReservations?: Maybe<Array<Maybe<PromoEvent>>>;
  getBucketFunds?: Maybe<Array<Maybe<BucketFund>>>;
  getBucketFundsContent?: Maybe<Array<Maybe<Content>>>;
  getContent?: Maybe<Content>;
  getEvent?: Maybe<Event>;
  getMtaa?: Maybe<Mtaa>;
  getMyOrders?: Maybe<Array<Maybe<CartItem>>>;
  getMyPayments?: Maybe<Array<Maybe<CartItem>>>;
  getPartnershipData?: Maybe<PartnershipProfile>;
  getSpecifiedAdds?: Maybe<Array<Maybe<Event>>>;
  getSpecifiedFunds?: Maybe<Array<Maybe<Event>>>;
  getUnspecifiedAdds?: Maybe<Array<Maybe<PromoBucket>>>;
  getUnspecifiedFunds?: Maybe<Array<Maybe<BucketFund>>>;
  managers?: Maybe<Array<Maybe<Manager>>>;
  myBanda?: Maybe<Banda>;
  myBandaEventsList?: Maybe<Array<Maybe<Event>>>;
  myBandaEventsPrivate?: Maybe<Array<Maybe<Event>>>;
  myContentEventsList?: Maybe<Array<Maybe<Event>>>;
  myContentsList?: Maybe<Array<Maybe<Content>>>;
  myEventsList?: Maybe<Array<Maybe<Event>>>;
  myNotifications?: Maybe<Array<Maybe<Notification>>>;
  myPaidCart?: Maybe<Array<Maybe<MainCart>>>;
  myPaymentCart?: Maybe<Array<Maybe<MainCart>>>;
  myPaymentCartAdds?: Maybe<Array<Maybe<CartItem>>>;
  order?: Maybe<PaymentOrder>;
  paidCart?: Maybe<Array<Maybe<CartItem>>>;
  paymentCart?: Maybe<Array<Maybe<MainCart>>>;
  searchBandaByCodeManage?: Maybe<Array<Maybe<BandaManageI>>>;
  sendingInvoiceItemList?: Maybe<Array<Maybe<MainCart>>>;
  sponsor?: Maybe<Sponsor>;
  sponsorDashboard?: Maybe<DashboardOutput>;
  sponsorEventsList?: Maybe<Array<Maybe<Event>>>;
  sponsorGallery?: Maybe<Array<Maybe<Gallery>>>;
  sponsorOrders: LData;
  sponsors?: Maybe<SponsorPage>;
  user?: Maybe<UserProfile>;
  userAndPosts: User;
  users: Array<Maybe<UserDataForList>>;
};


export type QueryATopicArgs = {
  getTopic?: InputMaybe<GetTopic>;
};


export type QueryAgendaListArgs = {
  feedInputData?: InputMaybe<FeedInputData>;
};


export type QueryAgendaListSearchArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryAgendaTopicsListArgs = {
  getTopicInAgendaData?: InputMaybe<GetTopicInAgendaData>;
};


export type QueryAllOrdersArgs = {
  ordersInput: OrdersInput;
};


export type QueryAllOrdersInCartArgs = {
  ordersInput: OrdersInput;
};


export type QueryBandaListArgs = {
  feedInputData?: InputMaybe<FeedInputData>;
};


export type QueryBandaListFilterArgs = {
  bandaListFilterInput?: InputMaybe<BandaListFilterInput>;
};


export type QueryCheckSportsListArgs = {
  getSportsInput?: InputMaybe<GetSportsInput>;
};


export type QueryContentListArgs = {
  getContentsInput?: InputMaybe<GetContentsInput>;
};


export type QueryContentListCountArgs = {
  getContentsInput?: InputMaybe<GetContentsInput>;
};


export type QueryContentListManageArgs = {
  getContentsInput?: InputMaybe<GetContentsInput>;
};


export type QueryContentOwnerArgs = {
  getUserProfileInput: GetUserProfileInput;
};


export type QueryContentOwnersListArgs = {
  feedInputData: FeedInputData;
};


export type QueryEventsListArgs = {
  getEventsInput?: InputMaybe<GetEventsInput>;
};


export type QueryFeedArgs = {
  feedInputData?: InputMaybe<FeedInputData>;
};


export type QueryFilterAreasArgs = {
  feedInputData?: InputMaybe<FeedInputData>;
};


export type QueryGetBandaArgs = {
  findBandaumizaInput?: InputMaybe<FindBandaumizaInput>;
};


export type QueryGetBandaByCodeArgs = {
  feedInputData: FeedInputData;
};


export type QueryGetBandaByCodePromoArgs = {
  feedInputPromoData: FeedInputPromoData;
};


export type QueryGetBandaFundedArgs = {
  getEventsInput: GetEventsInput;
};


export type QueryGetBandaReservationsArgs = {
  getEventsInput: GetEventsInput;
};


export type QueryGetBucketFundsArgs = {
  feedInputData?: InputMaybe<FeedInputData>;
};


export type QueryGetBucketFundsContentArgs = {
  feedInputData?: InputMaybe<FeedInputData>;
};


export type QueryGetContentArgs = {
  getContentInput?: InputMaybe<GetContentInput>;
};


export type QueryGetEventArgs = {
  getEventInput?: InputMaybe<GetEventInput>;
};


export type QueryGetMtaaArgs = {
  mtaaInput: MtaaInput;
};


export type QueryGetMyOrdersArgs = {
  feedInputData: FeedInputData;
};


export type QueryGetMyPaymentsArgs = {
  feedInputData: FeedInputData;
};


export type QueryGetPartnershipDataArgs = {
  getUserProfileInput: GetUserProfileInput;
};


export type QueryGetSpecifiedAddsArgs = {
  feedInputData?: InputMaybe<FeedInputData>;
};


export type QueryGetSpecifiedFundsArgs = {
  feedInputData?: InputMaybe<FeedInputData>;
};


export type QueryGetUnspecifiedAddsArgs = {
  feedInputData?: InputMaybe<FeedInputData>;
};


export type QueryGetUnspecifiedFundsArgs = {
  feedInputData?: InputMaybe<FeedInputData>;
};


export type QueryManagersArgs = {
  getUserProfileInput: GetUserProfileInput;
};


export type QueryMyBandaArgs = {
  getMyBandaInput?: InputMaybe<GetMyBandaInput>;
};


export type QueryMyBandaEventsListArgs = {
  getMyBandaEventsInput?: InputMaybe<GetContentInput>;
};


export type QueryMyBandaEventsPrivateArgs = {
  getMyBandaInput?: InputMaybe<GetMyBandaInput>;
};


export type QueryMyContentEventsListArgs = {
  getMyBandaEventsInput?: InputMaybe<GetContentInput>;
};


export type QueryMyContentsListArgs = {
  getMyContentInput?: InputMaybe<GetMyContentInput>;
};


export type QueryMyEventsListArgs = {
  getContentInput?: InputMaybe<GetContentInput>;
};


export type QueryMyNotificationsArgs = {
  getMyContentInput?: InputMaybe<GetMyContentInput>;
};


export type QueryMyPaidCartArgs = {
  ordersInput: OrdersInput;
};


export type QueryMyPaymentCartArgs = {
  ordersInput: OrdersInput;
};


export type QueryMyPaymentCartAddsArgs = {
  ordersInput: OrdersInput;
};


export type QueryOrderArgs = {
  ordersInput: OrdersInput;
};


export type QueryPaidCartArgs = {
  ordersInput: OrdersInput;
};


export type QueryPaymentCartArgs = {
  ordersInput: OrdersInput;
};


export type QuerySearchBandaByCodeManageArgs = {
  feedInputDataCodeManage: FeedInputDataCodeManage;
};


export type QuerySendingInvoiceItemListArgs = {
  feedInputData: FeedInputData;
};


export type QuerySponsorArgs = {
  getSponsorProfileInput: GetSponsorProfileInput;
};


export type QuerySponsorDashboardArgs = {
  getSponsorProfileInput: GetSponsorProfileInput;
};


export type QuerySponsorEventsListArgs = {
  getContentInput?: InputMaybe<GetContentInput>;
};


export type QuerySponsorGalleryArgs = {
  feedInputData?: InputMaybe<FeedInputData>;
};


export type QuerySponsorOrdersArgs = {
  getSponsorProfileInput: GetSponsorProfileInput;
};


export type QuerySponsorsArgs = {
  getSponsorsInput: GetSponsorsInput;
};


export type QueryUserArgs = {
  getUserProfileInput: GetUserProfileInput;
};


export type QueryUserAndPostsArgs = {
  userAndPostsInput: UserAndPostsInput;
};


export type QueryUsersArgs = {
  getUserProfileInput: GetUserProfileInput;
};

export type Region = {
  __typename?: 'Region';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  districts?: Maybe<Array<Maybe<District>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RegionData = {
  __typename?: 'RegionData';
  areaName?: Maybe<Scalars['String']['output']>;
  bandaNumber?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  districtName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  mtaa?: Maybe<Array<Maybe<Mtaa>>>;
  regionName?: Maybe<Scalars['String']['output']>;
  wardName?: Maybe<Scalars['String']['output']>;
};

export type RegisterBandaInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  ageRestriction?: InputMaybe<Scalars['String']['input']>;
  airConditioner?: InputMaybe<Scalars['Boolean']['input']>;
  bandaName?: InputMaybe<Scalars['String']['input']>;
  bandaPassword?: InputMaybe<Scalars['String']['input']>;
  bandaSize?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  closingTime?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  decoders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  district?: InputMaybe<Scalars['String']['input']>;
  districtPostcode?: InputMaybe<Scalars['String']['input']>;
  drinks?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feni?: InputMaybe<Scalars['Boolean']['input']>;
  food?: InputMaybe<Scalars['Boolean']['input']>;
  geRestriction?: InputMaybe<Scalars['String']['input']>;
  generator?: InputMaybe<Scalars['Boolean']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
  laptop?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mtaaName?: InputMaybe<Scalars['String']['input']>;
  nafasiWazi?: InputMaybe<Scalars['Boolean']['input']>;
  nationalID?: InputMaybe<Scalars['String']['input']>;
  numberOfTv?: InputMaybe<Scalars['Int']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  physicalResidency?: InputMaybe<Scalars['String']['input']>;
  priceHour?: InputMaybe<Scalars['Float']['input']>;
  projector?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  tvSize?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeOfSeats?: InputMaybe<Scalars['String']['input']>;
  umeme?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  vikalioKutoka?: InputMaybe<Scalars['Boolean']['input']>;
  ward?: InputMaybe<Scalars['String']['input']>;
  wardPostcode?: InputMaybe<Scalars['String']['input']>;
  wifi?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegisterContentInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isCompany?: InputMaybe<Scalars['Boolean']['input']>;
  mtaa?: InputMaybe<Scalars['String']['input']>;
  nationalID?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  physicalResidency?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  ward?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterInput = {
  password: Scalars['String']['input'];
  regData: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterManagerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expireAt?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  manageKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  physicalResidency?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  userNationalId?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterSponsorInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  companyID?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contentOwnership?: InputMaybe<Scalars['Boolean']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isCompany?: InputMaybe<Scalars['Boolean']['input']>;
  mtaa?: InputMaybe<Scalars['String']['input']>;
  nationalID?: InputMaybe<Scalars['String']['input']>;
  organisationDoc?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  physicalResidency?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  usernameSponsor?: InputMaybe<Scalars['String']['input']>;
  ward?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationData = {
  __typename?: 'RegistrationData';
  log: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type RegistrationSponsorData = {
  __typename?: 'RegistrationSponsorData';
  log: Scalars['Boolean']['output'];
  mode: Scalars['String']['output'];
};

export type RenewPasswordRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type Response = {
  __typename?: 'Response';
  message?: Maybe<Scalars['String']['output']>;
  newId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ScheduleDetails = {
  end?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleDetailsData = {
  __typename?: 'ScheduleDetailsData';
  end?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SearchInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type Sponsor = {
  __typename?: 'Sponsor';
  address?: Maybe<Scalars['String']['output']>;
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  cartItem?: Maybe<Array<Maybe<CartItem>>>;
  companyID?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contentOwnership?: Maybe<Scalars['Boolean']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  isCompany?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mtaa?: Maybe<Scalars['String']['output']>;
  otherProfileLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  physicalResidency?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  socialLinks?: Maybe<Scalars['String']['output']>;
  sponsorName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userNationalId?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
  verifiedInt?: Maybe<Scalars['Boolean']['output']>;
  verifiedIntAt?: Maybe<Scalars['String']['output']>;
  ward?: Maybe<Scalars['String']['output']>;
};

export type SponsorDataInfo = {
  __typename?: 'SponsorDataInfo';
  companyAddress?: Maybe<Scalars['String']['output']>;
  companyCreatedAt?: Maybe<Scalars['String']['output']>;
  companyEmail?: Maybe<Scalars['String']['output']>;
  companyID?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['String']['output']>;
  companyPhysicalResidency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type SponsorOrders = {
  __typename?: 'SponsorOrders';
  bandaAndAreaItems?: Maybe<Array<Maybe<CartItemsType>>>;
  contentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isBusket?: Maybe<Scalars['Boolean']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SponsorPage = {
  __typename?: 'SponsorPage';
  count?: Maybe<Scalars['Int']['output']>;
  list?: Maybe<Array<Maybe<Sponsor>>>;
};

export type SponsorProfile = {
  __typename?: 'SponsorProfile';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sponsor?: Maybe<Sponsor>;
  username?: Maybe<Scalars['String']['output']>;
};

export type SponsorProfileOrder = {
  __typename?: 'SponsorProfileOrder';
  bandaAndAreaItems?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SubInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  timeFreq?: InputMaybe<Scalars['Int']['input']>;
};

export enum SubPlan {
  Daily = 'DAILY',
  Free = 'FREE',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type SuperAdminInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

export type TagsPosts = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TheClientAppStatusI = {
  __typename?: 'TheClientAppStatusI';
  addedAddress?: Maybe<Scalars['Boolean']['output']>;
  addedAddress_waiting?: Maybe<Scalars['Boolean']['output']>;
  addedWadhamini?: Maybe<Scalars['Boolean']['output']>;
  addedWadhamini_waiting?: Maybe<Scalars['Boolean']['output']>;
  nidaVerified?: Maybe<Scalars['Boolean']['output']>;
  nidaVerified_waiting?: Maybe<Scalars['Boolean']['output']>;
  phoneNoVerified?: Maybe<Scalars['Boolean']['output']>;
  phoneNoVerified_waiting?: Maybe<Scalars['Boolean']['output']>;
  policeClearanced?: Maybe<Scalars['Boolean']['output']>;
  policeClearanced_waiting?: Maybe<Scalars['Boolean']['output']>;
  waitingForCode?: Maybe<Scalars['Boolean']['output']>;
  waitingForCode_waiting?: Maybe<Scalars['Boolean']['output']>;
};

export type TokenData = {
  __typename?: 'TokenData';
  access_token?: Maybe<Scalars['String']['output']>;
  account_status?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  msg?: Maybe<Scalars['String']['output']>;
};

export type TokenDataMobile = {
  __typename?: 'TokenDataMobile';
  access_token?: Maybe<Scalars['String']['output']>;
  account_status?: Maybe<Scalars['String']['output']>;
  log: Scalars['Boolean']['output'];
  refresh_token?: Maybe<Scalars['String']['output']>;
};

export type UpdateAuthInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  posts?: Maybe<Array<Maybe<Post>>>;
  username: Scalars['String']['output'];
};

export type UserAndPostsInput = {
  id: Scalars['String']['input'];
};

export type UserDataForList = {
  __typename?: 'UserDataForList';
  address?: Maybe<Scalars['String']['output']>;
  bandaUmizaList?: Maybe<Array<Maybe<Banda>>>;
  companyID?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  isBandaUmiza?: Maybe<Scalars['Boolean']['output']>;
  isCompany?: Maybe<Scalars['Boolean']['output']>;
  isContentOwner?: Maybe<Scalars['Boolean']['output']>;
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  physicalResidency?: Maybe<Scalars['String']['output']>;
  sponsor?: Maybe<Sponsor>;
  userNationalId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  verifiedContentOwner?: Maybe<Scalars['Boolean']['output']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  accountFeedBacks?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  bandaUmizaList?: Maybe<Array<Maybe<Banda>>>;
  contents?: Maybe<Array<Maybe<Content>>>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isBandaUmiza?: Maybe<Scalars['Boolean']['output']>;
  isContentOwner?: Maybe<Scalars['Boolean']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  physicalResidency?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  sponsor?: Maybe<Sponsor>;
  userNationalId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  verifiedContentOwner?: Maybe<Scalars['Boolean']['output']>;
  ward?: Maybe<Scalars['String']['output']>;
};

export type UseristI = {
  __typename?: 'UseristI';
  address?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contentOwnershipName?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  isCompany?: Maybe<Scalars['Boolean']['output']>;
  isContentOwner?: Maybe<Scalars['Boolean']['output']>;
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  physicalResidency?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  ward?: Maybe<Scalars['String']['output']>;
};

export type VerifyCodeService = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyContentOwnerInput = {
  userId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type VerifyEmailRequestInput = {
  id: Scalars['String']['input'];
};

export type VerifyNidaInput = {
  Nida?: InputMaybe<Scalars['Int']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyPhoneRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyReturnType = {
  __typename?: 'VerifyReturnType';
  log: Scalars['Boolean']['output'];
  msg: Scalars['String']['output'];
  status: PartnerShipSteps;
};

export type VerifySponsorInput = {
  sponsorId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type VerifyTokenService = {
  emailCode?: InputMaybe<Scalars['String']['input']>;
  emailToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyTokenType = {
  __typename?: 'VerifyTokenType';
  log: Scalars['Boolean']['output'];
  msg?: Maybe<Scalars['String']['output']>;
};

export type Ward = {
  __typename?: 'Ward';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  districtData?: Maybe<District>;
  districtId?: Maybe<Scalars['String']['output']>;
  districtName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mtaa?: Maybe<Array<Maybe<Mtaa>>>;
  name?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
};

export type CheckUserAuth = {
  __typename?: 'checkUserAuth';
  username: Scalars['String']['output'];
};

export type GetMyOrdersQueryVariables = Exact<{
  feedInputData: FeedInputData;
}>;


export type GetMyOrdersQuery = { __typename?: 'Query', getMyOrders?: Array<{ __typename?: 'CartItem', id?: string | null, contentId?: string | null, promoId?: string | null, isPromo?: boolean | null, closed?: boolean | null, activated?: boolean | null, itemName?: string | null, invoiceId?: string | null, totalAmount?: number | null, currency?: string | null, orderSteps?: OrderSteps | null, sponsorId?: string | null, userId?: string | null, createdAt?: any | null, sponsor?: { __typename?: 'Sponsor', id?: string | null, sponsorName?: string | null, companyName?: string | null } | null, orders?: Array<{ __typename?: 'PaymentOrder', id?: string | null } | null> | null, bucketFund?: Array<{ __typename?: 'BucketFund', id?: string | null, contentName?: string | null, currency?: string | null, specifiedArea?: string | null, amount?: number | null, frequency?: number | null, isPromoted?: boolean | null, orderType?: OrderType | null } | null> | null, promoBucket?: Array<{ __typename?: 'PromoBucket', id?: string | null, AddName?: string | null, currency?: string | null, specifiedArea?: string | null, amount?: number | null, frequency?: number | null, isPromoted?: boolean | null, orderType?: OrderType | null } | null> | null, events?: Array<{ __typename?: 'Event', id?: string | null, title?: string | null, currency?: string | null, bandaCode?: string | null, amount?: number | null, frequency?: number | null, orderType?: OrderType | null, isPromoted?: boolean | null } | null> | null, promoEvents?: Array<{ __typename?: 'PromoEvent', id?: string | null, title?: string | null, currency?: string | null, bandaCode?: string | null, orderType?: OrderType | null, frequency?: number | null, isPromoted?: boolean | null, amount?: number | null } | null> | null } | null> | null };

export type GetMyPaymentsQueryVariables = Exact<{
  feedInputData: FeedInputData;
}>;


export type GetMyPaymentsQuery = { __typename?: 'Query', getMyPayments?: Array<{ __typename?: 'CartItem', id?: string | null, contentId?: string | null, promoId?: string | null, closed?: boolean | null, activated?: boolean | null, isPromo?: boolean | null, totalAmount?: number | null, invoiceId?: string | null, currency?: string | null, sponsorId?: string | null, userId?: string | null, createdAt?: any | null, sponsor?: { __typename?: 'Sponsor', id?: string | null, sponsorName?: string | null, companyName?: string | null } | null, orders?: Array<{ __typename?: 'PaymentOrder', id?: string | null } | null> | null, bucketFund?: Array<{ __typename?: 'BucketFund', id?: string | null, contentName?: string | null, currency?: string | null, specifiedArea?: string | null, amount?: number | null, frequency?: number | null, isPromoted?: boolean | null, orderType?: OrderType | null } | null> | null, promoBucket?: Array<{ __typename?: 'PromoBucket', id?: string | null, AddName?: string | null, currency?: string | null, specifiedArea?: string | null, amount?: number | null, orderType?: OrderType | null, frequency?: number | null, isPromoted?: boolean | null } | null> | null, events?: Array<{ __typename?: 'Event', id?: string | null, title?: string | null, currency?: string | null, bandaCode?: string | null, orderType?: OrderType | null, amount?: number | null, frequency?: number | null, isPromoted?: boolean | null } | null> | null, promoEvents?: Array<{ __typename?: 'PromoEvent', id?: string | null, title?: string | null, currency?: string | null, bandaCode?: string | null, orderType?: OrderType | null, frequency?: number | null, isPromoted?: boolean | null, amount?: number | null } | null> | null } | null> | null };

export type AddBandaGalleryImageMutationVariables = Exact<{
  imageInput: ImageInput;
}>;


export type AddBandaGalleryImageMutation = { __typename?: 'Mutation', addBandaGalleryImage: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type AddBandaProfileImageMutationVariables = Exact<{
  imageInput: ImageInput;
}>;


export type AddBandaProfileImageMutation = { __typename?: 'Mutation', addBandaProfileImage: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type AddCartMutationVariables = Exact<{
  addCartInput: AddCartInput;
}>;


export type AddCartMutation = { __typename?: 'Mutation', addCart?: { __typename?: 'Response', status?: boolean | null } | null };

export type AddCoverImageMutationVariables = Exact<{
  imageInput: ImageInput;
}>;


export type AddCoverImageMutation = { __typename?: 'Mutation', addCoverImage: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type AddUserProfileImageMutationVariables = Exact<{
  imageInput: ImageInput;
}>;


export type AddUserProfileImageMutation = { __typename?: 'Mutation', addUserProfileImage: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type AddSponsorGalleryImageMutationVariables = Exact<{
  galleryInput: GalleryInput;
}>;


export type AddSponsorGalleryImageMutation = { __typename?: 'Mutation', addSponsorGalleryImage: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type AutoLoginMobileMutationVariables = Exact<{
  autoLoginMobileInput: AutoLoginMobileInput;
}>;


export type AutoLoginMobileMutation = { __typename?: 'Mutation', autoLoginMobile: { __typename?: 'TokenDataMobile', access_token?: string | null, refresh_token?: string | null, account_status?: string | null, log: boolean } };

export type BandaListFilterQueryVariables = Exact<{
  bandaListFilterInput: BandaListFilterInput;
}>;


export type BandaListFilterQuery = { __typename?: 'Query', bandaListFilter?: { __typename?: 'BandaPage', count?: number | null, list?: Array<{ __typename?: 'Banda', bandaName?: string | null, ownerName?: string | null, phoneNumber?: string | null, email?: string | null, bandaCode?: string | null, media?: string | null, location?: string | null, decoders?: string | null, region?: string | null, district?: string | null, ward?: string | null, tvSize?: string | null, address?: string | null, vikalioKutoka?: boolean | null, generator?: boolean | null, food?: boolean | null, feni?: boolean | null, drinks?: boolean | null, coverImage?: string | null, userNationalId?: string | null, capacity?: number | null, physicalResidency?: string | null, verified?: boolean | null, blocked?: boolean | null, userId?: string | null, createdAt?: any | null, id?: string | null, mtaa?: { __typename?: 'Mtaa', nameWardCode?: string | null, name?: string | null } | null, eventsFunds?: Array<{ __typename?: 'Event', id?: string | null, description?: string | null, startDateTime?: string | null, endDateTime?: string | null } | null> | null } | null> | null } | null };

export type UpdateBandaWorkingHoursMutationVariables = Exact<{
  bandaWorkingHoursInput: BandaWorkingHoursInput;
}>;


export type UpdateBandaWorkingHoursMutation = { __typename?: 'Mutation', updateBandaWorkingHours: { __typename?: 'RegistrationData', message?: string | null, log: boolean } };

export type BlockSponsorMutationVariables = Exact<{
  verifySponsorInput: VerifySponsorInput;
}>;


export type BlockSponsorMutation = { __typename?: 'Mutation', blockSponsor: { __typename?: 'RegistrationData', log: boolean } };

export type ContentListCountQueryVariables = Exact<{
  getContentsInput: GetContentsInput;
}>;


export type ContentListCountQuery = { __typename?: 'Query', contentListCount?: { __typename?: 'Counted', count?: number | null } | null };

export type ContentOwnersListQueryVariables = Exact<{
  feedInputData: FeedInputData;
}>;


export type ContentOwnersListQuery = { __typename?: 'Query', contentOwnersList?: { __typename?: 'ContentOwnersPage', count?: number | null, list?: Array<{ __typename?: 'UseristI', id?: string | null, username?: string | null, isCompany?: boolean | null, contentOwnershipName?: string | null, companyName?: string | null, coverImage?: string | null, address?: string | null, physicalResidency?: string | null, verified?: boolean | null, disabled?: boolean | null, isContentOwner?: boolean | null, isPartner?: boolean | null, createdAt?: any | null } | null> | null } | null };

export type CreateEventMutationVariables = Exact<{
  createEventInput: CreateEventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type AddTopicToAgendaMutationVariables = Exact<{
  addTopicInAgenda: IAddTopicInAgenda;
}>;


export type AddTopicToAgendaMutation = { __typename?: 'Mutation', addTopicToAgenda: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type DeleteSponsorGalleryImageMutationVariables = Exact<{
  imageInput: ImageInput;
}>;


export type DeleteSponsorGalleryImageMutation = { __typename?: 'Mutation', deleteSponsorGalleryImage: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type DisableContentMutationVariables = Exact<{
  deleteEvent: DeleteEvent;
}>;


export type DisableContentMutation = { __typename?: 'Mutation', disableContent: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type EditContentMutationVariables = Exact<{
  editContentInput: EditContentInput;
}>;


export type EditContentMutation = { __typename?: 'Mutation', editContent: { __typename?: 'ConfirmedResponse', status?: boolean | null, message?: string | null } };

export type FilterAreasQueryVariables = Exact<{
  feedInputData: FeedInputData;
}>;


export type FilterAreasQuery = { __typename?: 'Query', filterAreas?: Array<{ __typename?: 'AreaData', id?: string | null, country?: string | null, regionName?: string | null, districtName?: string | null, wardName?: string | null, areaName?: string | null, bandaNumber?: number | null, isActive?: boolean | null, areaType?: string | null } | null> | null };

export type ATopicQueryVariables = Exact<{
  getTopic: GetTopic;
}>;


export type ATopicQuery = { __typename?: 'Query', aTopic?: { __typename?: 'Post', statement?: string | null, title?: string | null, description?: string | null, createdAt?: any | null, media?: Array<string | null> | null, topic?: string | null } | null };

export type BandaListQueryVariables = Exact<{
  feedInputData: FeedInputData;
}>;


export type BandaListQuery = { __typename?: 'Query', bandaList?: Array<{ __typename?: 'Banda', bandaName?: string | null, ownerName?: string | null, phoneNumber?: string | null, email?: string | null, bandaCode?: string | null, district?: string | null, region?: string | null, ward?: string | null, media?: string | null, location?: string | null, address?: string | null, coverImage?: string | null, userNationalId?: string | null, capacity?: number | null, physicalResidency?: string | null, verified?: boolean | null, blocked?: boolean | null, userId?: string | null, createdAt?: any | null, decoders?: string | null, tvSize?: string | null, id?: string | null, mtaa?: { __typename?: 'Mtaa', nameWardCode?: string | null, name?: string | null } | null, eventsFunds?: Array<{ __typename?: 'Event', id?: string | null, description?: string | null, startDateTime?: string | null, endDateTime?: string | null } | null> | null } | null> | null };

export type GetBandaByCodeQueryVariables = Exact<{
  feedInputData: FeedInputData;
}>;


export type GetBandaByCodeQuery = { __typename?: 'Query', getBandaByCode?: Array<{ __typename?: 'Banda', bandaName?: string | null, ownerName?: string | null, bandaCode?: string | null, media?: string | null, location?: string | null, priceHour?: number | null, currency?: string | null, district?: string | null, region?: string | null, ward?: string | null, address?: string | null, capacity?: number | null, numberOfTv?: number | null, physicalResidency?: string | null, userId?: string | null, createdAt?: any | null, decoders?: string | null, id?: string | null, eventsFunds?: Array<{ __typename?: 'Event', id?: string | null, title?: string | null, startDateTime?: string | null, endDateTime?: string | null, eventType?: EventType | null } | null> | null } | null> | null };

export type GetBandaByCodePromoQueryVariables = Exact<{
  feedInputPromoData: FeedInputPromoData;
}>;


export type GetBandaByCodePromoQuery = { __typename?: 'Query', getBandaByCodePromo?: Array<{ __typename?: 'Banda', bandaName?: string | null, ownerName?: string | null, bandaCode?: string | null, media?: string | null, location?: string | null, priceHour?: number | null, currency?: string | null, district?: string | null, region?: string | null, ward?: string | null, address?: string | null, capacity?: number | null, numberOfTv?: number | null, physicalResidency?: string | null, userId?: string | null, createdAt?: any | null, decoders?: string | null, id?: string | null, eventsFunds?: Array<{ __typename?: 'Event', id?: string | null, title?: string | null, contentId?: string | null, startDateTime?: string | null, endDateTime?: string | null, eventType?: EventType | null } | null> | null } | null> | null };

export type GetBandaQueryVariables = Exact<{
  findBandaumizaInput: FindBandaumizaInput;
}>;


export type GetBandaQuery = { __typename?: 'Query', getBanda?: { __typename?: 'Banda', bandaName?: string | null, ownerName?: string | null, description?: string | null, phoneNumber?: string | null, email?: string | null, bandaCode?: string | null, media?: string | null, coverImage?: string | null, location?: string | null, priceHour?: number | null, currency?: string | null, address?: string | null, userNationalId?: string | null, bandaSize?: string | null, gallery?: Array<string | null> | null, capacity?: number | null, numberOfTv?: number | null, physicalResidency?: string | null, verified?: boolean | null, blocked?: boolean | null, userId?: string | null, createdAt?: any | null, district?: string | null, region?: string | null, ward?: string | null, mtaaName?: string | null, drinks?: boolean | null, food?: boolean | null, projector?: boolean | null, wifi?: boolean | null, generator?: boolean | null, vikalioKutoka?: boolean | null, laptop?: boolean | null, airConditioner?: boolean | null, feni?: boolean | null, decoders?: string | null, tvSize?: string | null, id?: string | null, mtaa?: { __typename?: 'Mtaa', nameWardCode?: string | null, name?: string | null } | null, eventsFunds?: Array<{ __typename?: 'Event', id?: string | null, description?: string | null, title?: string | null, createdAt?: any | null, scheduleData?: string | null, eventType?: EventType | null, contentId?: string | null, fundedBy?: string | null, sponsorId?: string | null, startDateTime?: string | null, endDateTime?: string | null, sponsor?: { __typename?: 'Sponsor', id?: string | null, isCompany?: boolean | null, coverImage?: string | null, sponsorName?: string | null, companyName?: string | null } | null, content?: { __typename?: 'Content', id?: string | null, author?: { __typename?: 'UserDataForList', id: string, username?: string | null } | null, categories?: Array<{ __typename?: 'Categories', name?: string | null } | null> | null } | null } | null> | null } | null };

export type GetBandaFundedQueryVariables = Exact<{
  getEventsInput: GetEventsInput;
}>;


export type GetBandaFundedQuery = { __typename?: 'Query', getBandaFunded?: Array<{ __typename?: 'Event', title?: string | null, createdAt?: any | null, published?: boolean | null, eventIdForPromo?: string | null, promoId?: string | null, currency?: string | null, contentId?: string | null, amount?: number | null, invoiceId?: string | null, bandaId?: string | null, sponsorId?: string | null, authorId?: string | null, breakDurationInMins?: number | null, breakFrequency?: number | null, eventType?: EventType | null, startDateTime?: string | null, endDateTime?: string | null, id?: string | null, userId?: string | null, description?: string | null, content?: { __typename?: 'Content', id?: string | null, languages?: string | null, categories?: Array<{ __typename?: 'Categories', name?: string | null } | null> | null } | null } | null> | null };

export type GetContentQueryVariables = Exact<{
  getContentInput: GetContentInput;
}>;


export type GetContentQuery = { __typename?: 'Query', getContent?: { __typename?: 'Content', title?: string | null, media?: string | null, link?: string | null, coverImage?: string | null, fundedBy?: number | null, createdAt?: any | null, duration?: number | null, amount?: number | null, verifiedBy?: string | null, currency?: string | null, published?: boolean | null, languages?: string | null, startDateTime?: string | null, endDateTime?: string | null, id?: string | null, userId?: string | null, description?: string | null, author?: { __typename?: 'UserDataForList', id: string, username?: string | null } | null, categories?: Array<{ __typename?: 'Categories', name?: string | null } | null> | null } | null };

export type MyContentEventsListQueryVariables = Exact<{
  getMyBandaEventsInput: GetContentInput;
}>;


export type MyContentEventsListQuery = { __typename?: 'Query', myContentEventsList?: Array<{ __typename?: 'Event', title?: string | null, createdAt?: any | null, published?: boolean | null, bandaCode?: string | null, startDateTime?: string | null, endDateTime?: string | null, id?: string | null, userId?: string | null, description?: string | null, sponsor?: { __typename?: 'Sponsor', id?: string | null, isCompany?: boolean | null, sponsorName?: string | null, coverImage?: string | null, companyName?: string | null } | null, banda?: { __typename?: 'Banda', id?: string | null, bandaName?: string | null, bandaCode?: string | null, coverImage?: string | null, address?: string | null, district?: string | null, region?: string | null, ward?: string | null, mtaaName?: string | null, physicalResidency?: string | null, capacity?: number | null, mtaa?: { __typename?: 'Mtaa', name?: string | null, regionData?: { __typename?: 'RegionData', country?: string | null, regionName?: string | null, districtName?: string | null, wardName?: string | null, areaName?: string | null } | null } | null } | null } | null> | null };

export type ContentListQueryVariables = Exact<{
  getContentsInput: GetContentsInput;
}>;


export type ContentListQuery = { __typename?: 'Query', contentList?: { __typename?: 'ContentPage', count?: number | null, list?: Array<{ __typename?: 'Content', title?: string | null, media?: string | null, link?: string | null, coverImage?: string | null, fundedBy?: number | null, createdAt?: any | null, amount?: number | null, currency?: string | null, published?: boolean | null, languages?: string | null, verifiedBy?: string | null, startDateTime?: string | null, endDateTime?: string | null, id?: string | null, userId?: string | null, description?: string | null, events?: Array<{ __typename?: 'Event', id?: string | null } | null> | null, author?: { __typename?: 'UserDataForList', id: string, username?: string | null, coverImage?: string | null } | null } | null> | null } | null };

export type GetEventQueryVariables = Exact<{
  getEventInput: GetEventInput;
}>;


export type GetEventQuery = { __typename?: 'Query', getEvent?: { __typename?: 'Event', title?: string | null, createdAt?: any | null, published?: boolean | null, eventIdForPromo?: string | null, promoId?: string | null, currency?: string | null, contentId?: string | null, orderSteps?: OrderSteps | null, amount?: number | null, invoiceId?: string | null, bandaId?: string | null, sponsorId?: string | null, authorId?: string | null, breakDurationInMins?: number | null, breakFrequency?: number | null, eventType?: EventType | null, startDateTime?: string | null, endDateTime?: string | null, id?: string | null, userId?: string | null, description?: string | null, content?: { __typename?: 'Content', id?: string | null, languages?: string | null, categories?: Array<{ __typename?: 'Categories', name?: string | null } | null> | null } | null } | null };

export type EventsListQueryVariables = Exact<{
  getEventsInput: GetEventsInput;
}>;


export type EventsListQuery = { __typename?: 'Query', eventsList?: Array<{ __typename?: 'Event', title?: string | null, createdAt?: any | null, published?: boolean | null, eventIdForPromo?: string | null, promoId?: string | null, currency?: string | null, contentId?: string | null, amount?: number | null, orderSteps?: OrderSteps | null, invoiceId?: string | null, bandaId?: string | null, sponsorId?: string | null, authorId?: string | null, breakDurationInMins?: number | null, breakFrequency?: number | null, eventType?: EventType | null, startDateTime?: string | null, endDateTime?: string | null, id?: string | null, userId?: string | null, coverImage?: string | null, description?: string | null, content?: { __typename?: 'Content', id?: string | null, languages?: string | null, coverImage?: string | null, categories?: Array<{ __typename?: 'Categories', name?: string | null } | null> | null } | null } | null> | null };

export type GetBandaReservationsQueryVariables = Exact<{
  getEventsInput: GetEventsInput;
}>;


export type GetBandaReservationsQuery = { __typename?: 'Query', getBandaReservations?: Array<{ __typename?: 'PromoEvent', title?: string | null, createdAt?: any | null, published?: boolean | null, eventIdForPromo?: string | null, promoId?: string | null, currency?: string | null, contentId?: string | null, amount?: number | null, invoiceId?: string | null, bandaId?: string | null, sponsorId?: string | null, authorId?: string | null, breakDurationInMins?: number | null, breakFrequency?: number | null, eventType?: EventType | null, startDateTime: any, endDateTime: any, id?: string | null, userId?: string | null, description?: string | null, event?: { __typename?: 'Event', id?: string | null, title?: string | null } | null } | null> | null };

export type GetMtaaQueryVariables = Exact<{
  mtaaInput: MtaaInput;
}>;


export type GetMtaaQuery = { __typename?: 'Query', getMtaa?: { __typename?: 'Mtaa', id?: string | null, name?: string | null, Population?: string | null, kaya?: string | null, Women?: string | null, Men?: string | null, Vijana?: string | null, Watoto?: string | null, wazee?: string | null, Attachments?: string | null, Details?: string | null, mwenyekiti?: string | null, watendaji?: string | null, mawasilianoMwenyekiti?: string | null, wardPostCode?: string | null, regionId?: string | null, wardId?: string | null, createdAt?: any | null, regionData?: { __typename?: 'RegionData', id?: string | null } | null, ward?: { __typename?: 'Ward', id?: string | null, name?: string | null, districtData?: { __typename?: 'District', name?: string | null, regionData?: { __typename?: 'Region', name?: string | null } | null } | null } | null, banda?: Array<{ __typename?: 'Banda', id?: string | null, bandaCode?: string | null } | null> | null, jembe?: Array<{ __typename?: 'Jembe', id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', id: string } | null> | null, matukio?: Array<{ __typename?: 'Event', id?: string | null } | null> | null, wananchi?: Array<{ __typename?: 'Mwananchi', id?: string | null } | null> | null } | null };

export type MyBandaEventsListQueryVariables = Exact<{
  getMyBandaEventsInput: GetContentInput;
}>;


export type MyBandaEventsListQuery = { __typename?: 'Query', myBandaEventsList?: Array<{ __typename?: 'Event', title?: string | null, createdAt?: any | null, published?: boolean | null, eventIdForPromo?: string | null, promoId?: string | null, currency?: string | null, contentId?: string | null, bandaCode?: string | null, amount?: number | null, invoiceId?: string | null, bandaId?: string | null, sponsorId?: string | null, authorId?: string | null, breakDurationInMins?: number | null, breakFrequency?: number | null, eventType?: EventType | null, startDateTime?: string | null, endDateTime?: string | null, id?: string | null, userId?: string | null, description?: string | null, content?: { __typename?: 'Content', id?: string | null, languages?: string | null, categories?: Array<{ __typename?: 'Categories', name?: string | null } | null> | null } | null } | null> | null };

export type MyBandaEventsPrivateQueryVariables = Exact<{
  getMyBandaInput: GetMyBandaInput;
}>;


export type MyBandaEventsPrivateQuery = { __typename?: 'Query', myBandaEventsPrivate?: Array<{ __typename?: 'Event', title?: string | null, createdAt?: any | null, published?: boolean | null, id?: string | null, description?: string | null } | null> | null };

export type MyContentsListQueryVariables = Exact<{
  getMyContentInput: GetMyContentInput;
}>;


export type MyContentsListQuery = { __typename?: 'Query', myContentsList?: Array<{ __typename?: 'Content', title?: string | null, media?: string | null, link?: string | null, coverImage?: string | null, amount?: number | null, currency?: string | null, fundedBy?: number | null, createdAt?: any | null, published?: boolean | null, languages?: string | null, id?: string | null, userId?: string | null, description?: string | null, author?: { __typename?: 'UserDataForList', id: string, username?: string | null } | null } | null> | null };

export type MyEventsListQueryVariables = Exact<{
  getContentInput: GetContentInput;
}>;


export type MyEventsListQuery = { __typename?: 'Query', myEventsList?: Array<{ __typename?: 'Event', title?: string | null, createdAt?: any | null, published?: boolean | null, contentId?: string | null, amount?: number | null, bandaCode?: string | null, orderSteps?: OrderSteps | null, invoiceId?: string | null, bandaId?: string | null, sponsorId?: string | null, eventType?: EventType | null, orderType?: OrderType | null, startDateTime?: string | null, endDateTime?: string | null, id?: string | null, userId?: string | null, description?: string | null, banda?: { __typename?: 'Banda', bandaName?: string | null, bandaCode?: string | null } | null } | null> | null };

export type MyNotificationsQueryVariables = Exact<{
  getMyContentInput: GetMyContentInput;
}>;


export type MyNotificationsQuery = { __typename?: 'Query', myNotifications?: Array<{ __typename?: 'Notification', id?: string | null, description?: string | null, title?: string | null, notificationType?: string | null, media?: string | null, isSeen?: boolean | null, createdAt?: any | null } | null> | null };

export type AgendaTopicsListQueryVariables = Exact<{
  getTopicInAgendaData: GetTopicInAgendaData;
}>;


export type AgendaTopicsListQuery = { __typename?: 'Query', agendaTopicsList?: { __typename?: 'AgendaPosts', id?: string | null, title?: string | null, statement?: string | null, dateOfEvent?: string | null, createdAt?: any | null, posts?: Array<{ __typename?: 'Post', id?: string | null, title?: string | null, topic?: string | null, statement?: string | null, dateOfEvent?: any | null, createdAt?: any | null } | null> | null } | null };

export type SponsorEventsListQueryVariables = Exact<{
  getContentInput: GetContentInput;
}>;


export type SponsorEventsListQuery = { __typename?: 'Query', sponsorEventsList?: Array<{ __typename?: 'Event', title?: string | null, createdAt?: any | null, published?: boolean | null, eventIdForPromo?: string | null, promoId?: string | null, currency?: string | null, contentId?: string | null, amount?: number | null, orderSteps?: OrderSteps | null, invoiceId?: string | null, bandaId?: string | null, sponsorId?: string | null, authorId?: string | null, breakDurationInMins?: number | null, breakFrequency?: number | null, eventType?: EventType | null, startDateTime?: string | null, endDateTime?: string | null, id?: string | null, userId?: string | null, description?: string | null, banda?: { __typename?: 'Banda', bandaCode?: string | null, bandaName?: string | null } | null, content?: { __typename?: 'Content', id?: string | null, coverImage?: string | null, languages?: string | null, author?: { __typename?: 'UserDataForList', id: string, username?: string | null } | null, categories?: Array<{ __typename?: 'Categories', name?: string | null } | null> | null } | null } | null> | null };

export type CheckSportsListQueryVariables = Exact<{
  getSportsInput: GetSportsInput;
}>;


export type CheckSportsListQuery = { __typename?: 'Query', checkSportsList?: Array<{ __typename?: 'Content', title?: string | null, media?: string | null, link?: string | null, coverImage?: string | null, fundedBy?: number | null, createdAt?: any | null, published?: boolean | null, languages?: string | null, startDateTime?: string | null, endDateTime?: string | null, id?: string | null, userId?: string | null, description?: string | null, author?: { __typename?: 'UserDataForList', id: string, username?: string | null } | null } | null> | null };

export type LoginMobileMutationVariables = Exact<{
  authLoginReg: AuthLoginReg;
}>;


export type LoginMobileMutation = { __typename?: 'Mutation', loginMobile: { __typename?: 'TokenDataMobile', access_token?: string | null, refresh_token?: string | null, account_status?: string | null, log: boolean } };

export type LoginBandaMutationVariables = Exact<{
  authLoginReg: AuthLoginReg;
}>;


export type LoginBandaMutation = { __typename?: 'Mutation', loginBanda: { __typename?: 'TokenDataMobile', access_token?: string | null, refresh_token?: string | null, account_status?: string | null, log: boolean } };

export type LogoutMobileMutationVariables = Exact<{
  logoutAuthInput?: InputMaybe<LogoutAuthInput>;
}>;


export type LogoutMobileMutation = { __typename?: 'Mutation', logoutMobile: { __typename?: 'LogoutData', log: boolean, msg?: string | null, tokenVersion: string } };

export type MyBandaQueryVariables = Exact<{
  getMyBandaInput: GetMyBandaInput;
}>;


export type MyBandaQuery = { __typename?: 'Query', myBanda?: { __typename?: 'Banda', bandaName?: string | null, ownerName?: string | null, description?: string | null, phoneNumber?: string | null, coverImage?: string | null, email?: string | null, bandaCode?: string | null, district?: string | null, region?: string | null, ward?: string | null, media?: string | null, location?: string | null, gallery?: Array<string | null> | null, address?: string | null, userNationalId?: string | null, capacity?: number | null, numberOfTv?: number | null, physicalResidency?: string | null, verified?: boolean | null, blocked?: boolean | null, userId?: string | null, createdAt?: any | null, decoders?: string | null, id?: string | null, mtaa?: { __typename?: 'Mtaa', nameWardCode?: string | null, name?: string | null } | null, addsPromo?: Array<{ __typename?: 'PromoEvent', id?: string | null } | null> | null, eventsFunds?: Array<{ __typename?: 'Event', id?: string | null, description?: string | null, startDateTime?: string | null, endDateTime?: string | null } | null> | null } | null };

export type MyPaymentCartQueryVariables = Exact<{
  ordersInput: OrdersInput;
}>;


export type MyPaymentCartQuery = { __typename?: 'Query', myPaymentCart?: Array<{ __typename?: 'MainCart', id?: string | null, invoiceId?: string | null, closed?: boolean | null, activated?: boolean | null, orderSteps?: OrderSteps | null, sponsorId?: string | null, userId?: string | null, totalAmount?: number | null, currency?: string | null, billingSource?: string | null, createdAt?: any | null, sponsor?: { __typename?: 'Sponsor', id?: string | null } | null, carts?: Array<{ __typename?: 'CartItem', id?: string | null, contentId?: string | null, promoId?: string | null, closed?: boolean | null, activated?: boolean | null, isPromo?: boolean | null, totalAmount?: number | null, invoiceId?: string | null, currency?: string | null, sponsorId?: string | null, userId?: string | null, createdAt?: any | null, sponsor?: { __typename?: 'Sponsor', id?: string | null, sponsorName?: string | null, companyName?: string | null } | null, orders?: Array<{ __typename?: 'PaymentOrder', id?: string | null } | null> | null, bucketFund?: Array<{ __typename?: 'BucketFund', id?: string | null, contentName?: string | null, currency?: string | null, specifiedArea?: string | null, amount?: number | null, frequency?: number | null, isPromoted?: boolean | null, orderType?: OrderType | null } | null> | null, promoBucket?: Array<{ __typename?: 'PromoBucket', id?: string | null, AddName?: string | null, currency?: string | null, specifiedArea?: string | null, amount?: number | null, orderType?: OrderType | null, frequency?: number | null, isPromoted?: boolean | null } | null> | null, events?: Array<{ __typename?: 'Event', id?: string | null, title?: string | null, currency?: string | null, bandaCode?: string | null, orderType?: OrderType | null, amount?: number | null, frequency?: number | null, isPromoted?: boolean | null } | null> | null, promoEvents?: Array<{ __typename?: 'PromoEvent', id?: string | null, title?: string | null, currency?: string | null, bandaCode?: string | null, orderType?: OrderType | null, frequency?: number | null, isPromoted?: boolean | null, amount?: number | null } | null> | null } | null> | null } | null> | null };

export type MyPaidCartQueryVariables = Exact<{
  ordersInput: OrdersInput;
}>;


export type MyPaidCartQuery = { __typename?: 'Query', myPaidCart?: Array<{ __typename?: 'MainCart', id?: string | null, invoiceId?: string | null, closed?: boolean | null, activated?: boolean | null, orderSteps?: OrderSteps | null, sponsorId?: string | null, userId?: string | null, totalAmount?: number | null, currency?: string | null, billingSource?: string | null, createdAt?: any | null, sponsor?: { __typename?: 'Sponsor', id?: string | null } | null, carts?: Array<{ __typename?: 'CartItem', id?: string | null, contentId?: string | null, promoId?: string | null, closed?: boolean | null, activated?: boolean | null, isPromo?: boolean | null, totalAmount?: number | null, invoiceId?: string | null, currency?: string | null, sponsorId?: string | null, userId?: string | null, createdAt?: any | null, sponsor?: { __typename?: 'Sponsor', id?: string | null, sponsorName?: string | null, companyName?: string | null } | null, orders?: Array<{ __typename?: 'PaymentOrder', id?: string | null } | null> | null, bucketFund?: Array<{ __typename?: 'BucketFund', id?: string | null, contentName?: string | null, currency?: string | null, specifiedArea?: string | null, amount?: number | null, frequency?: number | null, isPromoted?: boolean | null, orderType?: OrderType | null } | null> | null, promoBucket?: Array<{ __typename?: 'PromoBucket', id?: string | null, AddName?: string | null, currency?: string | null, specifiedArea?: string | null, amount?: number | null, orderType?: OrderType | null, frequency?: number | null, isPromoted?: boolean | null } | null> | null, events?: Array<{ __typename?: 'Event', id?: string | null, title?: string | null, currency?: string | null, bandaCode?: string | null, orderType?: OrderType | null, amount?: number | null, frequency?: number | null, isPromoted?: boolean | null } | null> | null, promoEvents?: Array<{ __typename?: 'PromoEvent', id?: string | null, title?: string | null, currency?: string | null, bandaCode?: string | null, orderType?: OrderType | null, frequency?: number | null, isPromoted?: boolean | null, amount?: number | null } | null> | null } | null> | null } | null> | null };

export type RegistrationMutationVariables = Exact<{
  registerInput: RegisterInput;
}>;


export type RegistrationMutation = { __typename?: 'Mutation', registration: { __typename?: 'RegistrationData', log: boolean, message?: string | null } };

export type RegistrationBandaMutationVariables = Exact<{
  registerBandaInput: RegisterBandaInput;
}>;


export type RegistrationBandaMutation = { __typename?: 'Mutation', registrationBanda: { __typename?: 'RegistrationSponsorData', log: boolean, mode: string } };

export type RegistrationContentOwnerMutationVariables = Exact<{
  registerContentInput: RegisterContentInput;
}>;


export type RegistrationContentOwnerMutation = { __typename?: 'Mutation', registrationContentOwner: { __typename?: 'RegistrationSponsorData', log: boolean, mode: string } };

export type RegistrationSponsorMutationVariables = Exact<{
  registerSponsorInput: RegisterSponsorInput;
}>;


export type RegistrationSponsorMutation = { __typename?: 'Mutation', registrationSponsor: { __typename?: 'RegistrationSponsorData', log: boolean, mode: string } };

export type RemoveBandaGalleryImageMutationVariables = Exact<{
  imageInput: ImageInput;
}>;


export type RemoveBandaGalleryImageMutation = { __typename?: 'Mutation', removeBandaGalleryImage: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type RemoveContentMutationVariables = Exact<{
  deleteEvent: DeleteEvent;
}>;


export type RemoveContentMutation = { __typename?: 'Mutation', removeContent: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type RemoveEventMutationVariables = Exact<{
  deleteEvent: DeleteEvent;
}>;


export type RemoveEventMutation = { __typename?: 'Mutation', removeEvent: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type RemoveSponsorGalleryImageMutationVariables = Exact<{
  imageInput: ImageInput;
}>;


export type RemoveSponsorGalleryImageMutation = { __typename?: 'Mutation', removeSponsorGalleryImage: { __typename?: 'ConfirmedResponse', message?: string | null, status?: boolean | null } };

export type SponsorQueryVariables = Exact<{
  getSponsorProfileInput: GetSponsorProfileInput;
}>;


export type SponsorQuery = { __typename?: 'Query', sponsor?: { __typename?: 'Sponsor', id?: string | null, sponsorName?: string | null, companyName?: string | null, phoneNumber?: string | null, bio?: string | null, email?: string | null, address?: string | null, contentOwnership?: boolean | null, socialLinks?: string | null, backgroundImage?: string | null, physicalResidency?: string | null, userNationalId?: string | null, companyID?: string | null, otherProfileLinks?: Array<string | null> | null, media?: Array<string | null> | null, coverImage?: string | null, verified?: boolean | null, isCompany?: boolean | null, anonymous?: boolean | null, industry?: string | null, region?: string | null, district?: string | null, ward?: string | null, mtaa?: string | null, blocked?: boolean | null, verifiedInt?: boolean | null, userId?: string | null, verifiedAt?: string | null, verifiedIntAt?: string | null, createdAt?: any | null, cartItem?: Array<{ __typename?: 'CartItem', id?: string | null, contentId?: string | null, promoId?: string | null, isPromo?: boolean | null, closed?: boolean | null, activated?: boolean | null, itemName?: string | null, totalAmount?: number | null, currency?: string | null, orderSteps?: OrderSteps | null, sponsorId?: string | null, userId?: string | null, sponsor?: { __typename?: 'Sponsor', id?: string | null, sponsorName?: string | null, companyName?: string | null, industry?: string | null, coverImage?: string | null, region?: string | null, district?: string | null, ward?: string | null, mtaa?: string | null } | null, orders?: Array<{ __typename?: 'PaymentOrder', id?: string | null } | null> | null } | null> | null } | null };

export type SponsorDashboardQueryVariables = Exact<{
  getSponsorProfileInput: GetSponsorProfileInput;
}>;


export type SponsorDashboardQuery = { __typename?: 'Query', sponsorDashboard?: { __typename?: 'DashboardOutput', banda?: number | null, amount?: number | null, people?: number | null, content?: number | null, reservations?: number | null, adds?: number | null, createdAt?: any | null } | null };

export type SponsorGalleryQueryVariables = Exact<{
  feedInputData: FeedInputData;
}>;


export type SponsorGalleryQuery = { __typename?: 'Query', sponsorGallery?: Array<{ __typename?: 'Gallery', id?: string | null, description?: string | null, title?: string | null, media?: Array<string | null> | null, coverImage?: string | null, published?: boolean | null, sponsorId?: string | null, userId?: string | null, eventId?: string | null, contentId?: string | null, bandaId?: string | null, createdAt?: any | null, authorSponsor?: { __typename?: 'Sponsor', id?: string | null } | null, event?: { __typename?: 'Event', id?: string | null } | null, content?: { __typename?: 'Content', id?: string | null } | null } | null> | null };

export type SponsorOrdersQueryVariables = Exact<{
  getSponsorProfileInput: GetSponsorProfileInput;
}>;


export type SponsorOrdersQuery = { __typename?: 'Query', sponsorOrders: { __typename?: 'LData', data: string } };

export type SponsorsQueryVariables = Exact<{
  getSponsorsInput: GetSponsorsInput;
}>;


export type SponsorsQuery = { __typename?: 'Query', sponsors?: { __typename?: 'SponsorPage', count?: number | null, list?: Array<{ __typename?: 'Sponsor', id?: string | null, sponsorName?: string | null, companyName?: string | null, phoneNumber?: string | null, bio?: string | null, email?: string | null, address?: string | null, region?: string | null, district?: string | null, industry?: string | null, ward?: string | null, physicalResidency?: string | null, userNationalId?: string | null, companyID?: string | null, otherProfileLinks?: Array<string | null> | null, coverImage?: string | null, media?: Array<string | null> | null, verified?: boolean | null, anonymous?: boolean | null, blocked?: boolean | null, verifiedInt?: boolean | null, userId?: string | null, verifiedAt?: string | null, verifiedIntAt?: string | null, createdAt?: any | null } | null> | null } | null };

export type AddSponsorSocialLinksMutationVariables = Exact<{
  editSponsorInput: EditSponsorInput;
}>;


export type AddSponsorSocialLinksMutation = { __typename?: 'Mutation', addSponsorSocialLinks: { __typename?: 'RegistrationData', log: boolean, message?: string | null } };

export type EditSponsorDataMutationVariables = Exact<{
  editSponsorInput: EditSponsorInput;
}>;


export type EditSponsorDataMutation = { __typename?: 'Mutation', editSponsorData: { __typename?: 'RegistrationData', log: boolean, message?: string | null } };

export type CreateContentMutationVariables = Exact<{
  createContentInput: CreateContentInput;
}>;


export type CreateContentMutation = { __typename?: 'Mutation', createContent: { __typename?: 'ConfirmedResponse', status?: boolean | null, message?: string | null } };

export type UserQueryVariables = Exact<{
  getUserProfileInput: GetUserProfileInput;
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'UserProfile', id?: string | null, username?: string | null, email?: string | null, phoneNumber?: string | null, fullName?: string | null, coverImage?: string | null, isContentOwner?: boolean | null, isBandaUmiza?: boolean | null, userNationalId?: string | null, address?: string | null, physicalResidency?: string | null, createdAt?: any | null, accountFeedBacks?: string | null, verified?: boolean | null, disabled?: boolean | null, bandaUmizaList?: Array<{ __typename?: 'Banda', bandaName?: string | null, ownerName?: string | null, description?: string | null, phoneNumber?: string | null, email?: string | null, bandaCode?: string | null, media?: string | null, location?: string | null, address?: string | null, userNationalId?: string | null, capacity?: number | null, numberOfTv?: number | null, physicalResidency?: string | null, verified?: boolean | null, blocked?: boolean | null, userId?: string | null, createdAt?: any | null } | null> | null, contents?: Array<{ __typename?: 'Content', id?: string | null, title?: string | null, coverImage?: string | null, fundedBy?: number | null, createdAt?: any | null, published?: boolean | null, languages?: string | null, categories?: Array<{ __typename?: 'Categories', name?: string | null } | null> | null } | null> | null, sponsor?: { __typename?: 'Sponsor', id?: string | null, userNationalId?: string | null, verified?: boolean | null, blocked?: boolean | null } | null } | null };


export const GetMyOrdersDocument = gql`
    query GetMyOrders($feedInputData: FeedInputData!) {
  getMyOrders(feedInputData: $feedInputData) {
    id
    contentId
    promoId
    isPromo
    closed
    activated
    itemName
    invoiceId
    totalAmount
    currency
    orderSteps
    sponsor {
      id
      sponsorName
      companyName
    }
    sponsorId
    userId
    orders {
      id
    }
    bucketFund {
      id
      contentName
      currency
      specifiedArea
      amount
      frequency
      isPromoted
      orderType
    }
    promoBucket {
      id
      AddName
      currency
      specifiedArea
      amount
      frequency
      isPromoted
      orderType
    }
    events {
      id
      title
      currency
      bandaCode
      amount
      frequency
      orderType
      isPromoted
    }
    promoEvents {
      id
      title
      currency
      bandaCode
      orderType
      frequency
      isPromoted
      amount
    }
    createdAt
  }
}
    `;

/**
 * __useGetMyOrdersQuery__
 *
 * To run a query within a React component, call `useGetMyOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrdersQuery({
 *   variables: {
 *      feedInputData: // value for 'feedInputData'
 *   },
 * });
 */
export function useGetMyOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetMyOrdersQuery, GetMyOrdersQueryVariables> & ({ variables: GetMyOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOrdersQuery, GetMyOrdersQueryVariables>(GetMyOrdersDocument, options);
      }
export function useGetMyOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOrdersQuery, GetMyOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOrdersQuery, GetMyOrdersQueryVariables>(GetMyOrdersDocument, options);
        }
export function useGetMyOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyOrdersQuery, GetMyOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyOrdersQuery, GetMyOrdersQueryVariables>(GetMyOrdersDocument, options);
        }
export type GetMyOrdersQueryHookResult = ReturnType<typeof useGetMyOrdersQuery>;
export type GetMyOrdersLazyQueryHookResult = ReturnType<typeof useGetMyOrdersLazyQuery>;
export type GetMyOrdersSuspenseQueryHookResult = ReturnType<typeof useGetMyOrdersSuspenseQuery>;
export type GetMyOrdersQueryResult = Apollo.QueryResult<GetMyOrdersQuery, GetMyOrdersQueryVariables>;
export const GetMyPaymentsDocument = gql`
    query GetMyPayments($feedInputData: FeedInputData!) {
  getMyPayments(feedInputData: $feedInputData) {
    id
    contentId
    promoId
    closed
    activated
    isPromo
    totalAmount
    invoiceId
    currency
    sponsor {
      id
      sponsorName
      companyName
    }
    sponsorId
    userId
    orders {
      id
    }
    bucketFund {
      id
      contentName
      currency
      specifiedArea
      amount
      frequency
      isPromoted
      orderType
    }
    promoBucket {
      id
      AddName
      currency
      specifiedArea
      amount
      orderType
      frequency
      isPromoted
    }
    events {
      id
      title
      currency
      bandaCode
      orderType
      amount
      frequency
      isPromoted
    }
    promoEvents {
      id
      title
      currency
      bandaCode
      orderType
      frequency
      isPromoted
      amount
    }
    createdAt
  }
}
    `;

/**
 * __useGetMyPaymentsQuery__
 *
 * To run a query within a React component, call `useGetMyPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPaymentsQuery({
 *   variables: {
 *      feedInputData: // value for 'feedInputData'
 *   },
 * });
 */
export function useGetMyPaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetMyPaymentsQuery, GetMyPaymentsQueryVariables> & ({ variables: GetMyPaymentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPaymentsQuery, GetMyPaymentsQueryVariables>(GetMyPaymentsDocument, options);
      }
export function useGetMyPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPaymentsQuery, GetMyPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPaymentsQuery, GetMyPaymentsQueryVariables>(GetMyPaymentsDocument, options);
        }
export function useGetMyPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyPaymentsQuery, GetMyPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyPaymentsQuery, GetMyPaymentsQueryVariables>(GetMyPaymentsDocument, options);
        }
export type GetMyPaymentsQueryHookResult = ReturnType<typeof useGetMyPaymentsQuery>;
export type GetMyPaymentsLazyQueryHookResult = ReturnType<typeof useGetMyPaymentsLazyQuery>;
export type GetMyPaymentsSuspenseQueryHookResult = ReturnType<typeof useGetMyPaymentsSuspenseQuery>;
export type GetMyPaymentsQueryResult = Apollo.QueryResult<GetMyPaymentsQuery, GetMyPaymentsQueryVariables>;
export const AddBandaGalleryImageDocument = gql`
    mutation AddBandaGalleryImage($imageInput: ImageInput!) {
  addBandaGalleryImage(imageInput: $imageInput) {
    message
    status
  }
}
    `;
export type AddBandaGalleryImageMutationFn = Apollo.MutationFunction<AddBandaGalleryImageMutation, AddBandaGalleryImageMutationVariables>;

/**
 * __useAddBandaGalleryImageMutation__
 *
 * To run a mutation, you first call `useAddBandaGalleryImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBandaGalleryImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBandaGalleryImageMutation, { data, loading, error }] = useAddBandaGalleryImageMutation({
 *   variables: {
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useAddBandaGalleryImageMutation(baseOptions?: Apollo.MutationHookOptions<AddBandaGalleryImageMutation, AddBandaGalleryImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBandaGalleryImageMutation, AddBandaGalleryImageMutationVariables>(AddBandaGalleryImageDocument, options);
      }
export type AddBandaGalleryImageMutationHookResult = ReturnType<typeof useAddBandaGalleryImageMutation>;
export type AddBandaGalleryImageMutationResult = Apollo.MutationResult<AddBandaGalleryImageMutation>;
export type AddBandaGalleryImageMutationOptions = Apollo.BaseMutationOptions<AddBandaGalleryImageMutation, AddBandaGalleryImageMutationVariables>;
export const AddBandaProfileImageDocument = gql`
    mutation AddBandaProfileImage($imageInput: ImageInput!) {
  addBandaProfileImage(imageInput: $imageInput) {
    message
    status
  }
}
    `;
export type AddBandaProfileImageMutationFn = Apollo.MutationFunction<AddBandaProfileImageMutation, AddBandaProfileImageMutationVariables>;

/**
 * __useAddBandaProfileImageMutation__
 *
 * To run a mutation, you first call `useAddBandaProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBandaProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBandaProfileImageMutation, { data, loading, error }] = useAddBandaProfileImageMutation({
 *   variables: {
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useAddBandaProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<AddBandaProfileImageMutation, AddBandaProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBandaProfileImageMutation, AddBandaProfileImageMutationVariables>(AddBandaProfileImageDocument, options);
      }
export type AddBandaProfileImageMutationHookResult = ReturnType<typeof useAddBandaProfileImageMutation>;
export type AddBandaProfileImageMutationResult = Apollo.MutationResult<AddBandaProfileImageMutation>;
export type AddBandaProfileImageMutationOptions = Apollo.BaseMutationOptions<AddBandaProfileImageMutation, AddBandaProfileImageMutationVariables>;
export const AddCartDocument = gql`
    mutation AddCart($addCartInput: AddCartInput!) {
  addCart(addCartInput: $addCartInput) {
    status
  }
}
    `;
export type AddCartMutationFn = Apollo.MutationFunction<AddCartMutation, AddCartMutationVariables>;

/**
 * __useAddCartMutation__
 *
 * To run a mutation, you first call `useAddCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCartMutation, { data, loading, error }] = useAddCartMutation({
 *   variables: {
 *      addCartInput: // value for 'addCartInput'
 *   },
 * });
 */
export function useAddCartMutation(baseOptions?: Apollo.MutationHookOptions<AddCartMutation, AddCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCartMutation, AddCartMutationVariables>(AddCartDocument, options);
      }
export type AddCartMutationHookResult = ReturnType<typeof useAddCartMutation>;
export type AddCartMutationResult = Apollo.MutationResult<AddCartMutation>;
export type AddCartMutationOptions = Apollo.BaseMutationOptions<AddCartMutation, AddCartMutationVariables>;
export const AddCoverImageDocument = gql`
    mutation AddCoverImage($imageInput: ImageInput!) {
  addCoverImage(imageInput: $imageInput) {
    message
    status
  }
}
    `;
export type AddCoverImageMutationFn = Apollo.MutationFunction<AddCoverImageMutation, AddCoverImageMutationVariables>;

/**
 * __useAddCoverImageMutation__
 *
 * To run a mutation, you first call `useAddCoverImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCoverImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCoverImageMutation, { data, loading, error }] = useAddCoverImageMutation({
 *   variables: {
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useAddCoverImageMutation(baseOptions?: Apollo.MutationHookOptions<AddCoverImageMutation, AddCoverImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCoverImageMutation, AddCoverImageMutationVariables>(AddCoverImageDocument, options);
      }
export type AddCoverImageMutationHookResult = ReturnType<typeof useAddCoverImageMutation>;
export type AddCoverImageMutationResult = Apollo.MutationResult<AddCoverImageMutation>;
export type AddCoverImageMutationOptions = Apollo.BaseMutationOptions<AddCoverImageMutation, AddCoverImageMutationVariables>;
export const AddUserProfileImageDocument = gql`
    mutation AddUserProfileImage($imageInput: ImageInput!) {
  addUserProfileImage(imageInput: $imageInput) {
    message
    status
  }
}
    `;
export type AddUserProfileImageMutationFn = Apollo.MutationFunction<AddUserProfileImageMutation, AddUserProfileImageMutationVariables>;

/**
 * __useAddUserProfileImageMutation__
 *
 * To run a mutation, you first call `useAddUserProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserProfileImageMutation, { data, loading, error }] = useAddUserProfileImageMutation({
 *   variables: {
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useAddUserProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<AddUserProfileImageMutation, AddUserProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserProfileImageMutation, AddUserProfileImageMutationVariables>(AddUserProfileImageDocument, options);
      }
export type AddUserProfileImageMutationHookResult = ReturnType<typeof useAddUserProfileImageMutation>;
export type AddUserProfileImageMutationResult = Apollo.MutationResult<AddUserProfileImageMutation>;
export type AddUserProfileImageMutationOptions = Apollo.BaseMutationOptions<AddUserProfileImageMutation, AddUserProfileImageMutationVariables>;
export const AddSponsorGalleryImageDocument = gql`
    mutation AddSponsorGalleryImage($galleryInput: GalleryInput!) {
  addSponsorGalleryImage(galleryInput: $galleryInput) {
    message
    status
  }
}
    `;
export type AddSponsorGalleryImageMutationFn = Apollo.MutationFunction<AddSponsorGalleryImageMutation, AddSponsorGalleryImageMutationVariables>;

/**
 * __useAddSponsorGalleryImageMutation__
 *
 * To run a mutation, you first call `useAddSponsorGalleryImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSponsorGalleryImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSponsorGalleryImageMutation, { data, loading, error }] = useAddSponsorGalleryImageMutation({
 *   variables: {
 *      galleryInput: // value for 'galleryInput'
 *   },
 * });
 */
export function useAddSponsorGalleryImageMutation(baseOptions?: Apollo.MutationHookOptions<AddSponsorGalleryImageMutation, AddSponsorGalleryImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSponsorGalleryImageMutation, AddSponsorGalleryImageMutationVariables>(AddSponsorGalleryImageDocument, options);
      }
export type AddSponsorGalleryImageMutationHookResult = ReturnType<typeof useAddSponsorGalleryImageMutation>;
export type AddSponsorGalleryImageMutationResult = Apollo.MutationResult<AddSponsorGalleryImageMutation>;
export type AddSponsorGalleryImageMutationOptions = Apollo.BaseMutationOptions<AddSponsorGalleryImageMutation, AddSponsorGalleryImageMutationVariables>;
export const AutoLoginMobileDocument = gql`
    mutation AutoLoginMobile($autoLoginMobileInput: AutoLoginMobileInput!) {
  autoLoginMobile(autoLoginMobileInput: $autoLoginMobileInput) {
    access_token
    refresh_token
    account_status
    log
  }
}
    `;
export type AutoLoginMobileMutationFn = Apollo.MutationFunction<AutoLoginMobileMutation, AutoLoginMobileMutationVariables>;

/**
 * __useAutoLoginMobileMutation__
 *
 * To run a mutation, you first call `useAutoLoginMobileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoLoginMobileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoLoginMobileMutation, { data, loading, error }] = useAutoLoginMobileMutation({
 *   variables: {
 *      autoLoginMobileInput: // value for 'autoLoginMobileInput'
 *   },
 * });
 */
export function useAutoLoginMobileMutation(baseOptions?: Apollo.MutationHookOptions<AutoLoginMobileMutation, AutoLoginMobileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoLoginMobileMutation, AutoLoginMobileMutationVariables>(AutoLoginMobileDocument, options);
      }
export type AutoLoginMobileMutationHookResult = ReturnType<typeof useAutoLoginMobileMutation>;
export type AutoLoginMobileMutationResult = Apollo.MutationResult<AutoLoginMobileMutation>;
export type AutoLoginMobileMutationOptions = Apollo.BaseMutationOptions<AutoLoginMobileMutation, AutoLoginMobileMutationVariables>;
export const BandaListFilterDocument = gql`
    query BandaListFilter($bandaListFilterInput: BandaListFilterInput!) {
  bandaListFilter(bandaListFilterInput: $bandaListFilterInput) {
    count
    list {
      bandaName
      ownerName
      phoneNumber
      email
      bandaCode
      media
      location
      decoders
      region
      district
      mtaa {
        nameWardCode
        name
      }
      ward
      tvSize
      address
      vikalioKutoka
      generator
      food
      feni
      drinks
      coverImage
      userNationalId
      capacity
      physicalResidency
      verified
      blocked
      userId
      createdAt
      eventsFunds {
        id
        description
        startDateTime
        endDateTime
      }
      id
    }
  }
}
    `;

/**
 * __useBandaListFilterQuery__
 *
 * To run a query within a React component, call `useBandaListFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useBandaListFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBandaListFilterQuery({
 *   variables: {
 *      bandaListFilterInput: // value for 'bandaListFilterInput'
 *   },
 * });
 */
export function useBandaListFilterQuery(baseOptions: Apollo.QueryHookOptions<BandaListFilterQuery, BandaListFilterQueryVariables> & ({ variables: BandaListFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BandaListFilterQuery, BandaListFilterQueryVariables>(BandaListFilterDocument, options);
      }
export function useBandaListFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BandaListFilterQuery, BandaListFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BandaListFilterQuery, BandaListFilterQueryVariables>(BandaListFilterDocument, options);
        }
export function useBandaListFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BandaListFilterQuery, BandaListFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BandaListFilterQuery, BandaListFilterQueryVariables>(BandaListFilterDocument, options);
        }
export type BandaListFilterQueryHookResult = ReturnType<typeof useBandaListFilterQuery>;
export type BandaListFilterLazyQueryHookResult = ReturnType<typeof useBandaListFilterLazyQuery>;
export type BandaListFilterSuspenseQueryHookResult = ReturnType<typeof useBandaListFilterSuspenseQuery>;
export type BandaListFilterQueryResult = Apollo.QueryResult<BandaListFilterQuery, BandaListFilterQueryVariables>;
export const UpdateBandaWorkingHoursDocument = gql`
    mutation UpdateBandaWorkingHours($bandaWorkingHoursInput: BandaWorkingHoursInput!) {
  updateBandaWorkingHours(bandaWorkingHoursInput: $bandaWorkingHoursInput) {
    message
    log
  }
}
    `;
export type UpdateBandaWorkingHoursMutationFn = Apollo.MutationFunction<UpdateBandaWorkingHoursMutation, UpdateBandaWorkingHoursMutationVariables>;

/**
 * __useUpdateBandaWorkingHoursMutation__
 *
 * To run a mutation, you first call `useUpdateBandaWorkingHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBandaWorkingHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBandaWorkingHoursMutation, { data, loading, error }] = useUpdateBandaWorkingHoursMutation({
 *   variables: {
 *      bandaWorkingHoursInput: // value for 'bandaWorkingHoursInput'
 *   },
 * });
 */
export function useUpdateBandaWorkingHoursMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBandaWorkingHoursMutation, UpdateBandaWorkingHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBandaWorkingHoursMutation, UpdateBandaWorkingHoursMutationVariables>(UpdateBandaWorkingHoursDocument, options);
      }
export type UpdateBandaWorkingHoursMutationHookResult = ReturnType<typeof useUpdateBandaWorkingHoursMutation>;
export type UpdateBandaWorkingHoursMutationResult = Apollo.MutationResult<UpdateBandaWorkingHoursMutation>;
export type UpdateBandaWorkingHoursMutationOptions = Apollo.BaseMutationOptions<UpdateBandaWorkingHoursMutation, UpdateBandaWorkingHoursMutationVariables>;
export const BlockSponsorDocument = gql`
    mutation BlockSponsor($verifySponsorInput: VerifySponsorInput!) {
  blockSponsor(verifySponsorInput: $verifySponsorInput) {
    log
  }
}
    `;
export type BlockSponsorMutationFn = Apollo.MutationFunction<BlockSponsorMutation, BlockSponsorMutationVariables>;

/**
 * __useBlockSponsorMutation__
 *
 * To run a mutation, you first call `useBlockSponsorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockSponsorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockSponsorMutation, { data, loading, error }] = useBlockSponsorMutation({
 *   variables: {
 *      verifySponsorInput: // value for 'verifySponsorInput'
 *   },
 * });
 */
export function useBlockSponsorMutation(baseOptions?: Apollo.MutationHookOptions<BlockSponsorMutation, BlockSponsorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockSponsorMutation, BlockSponsorMutationVariables>(BlockSponsorDocument, options);
      }
export type BlockSponsorMutationHookResult = ReturnType<typeof useBlockSponsorMutation>;
export type BlockSponsorMutationResult = Apollo.MutationResult<BlockSponsorMutation>;
export type BlockSponsorMutationOptions = Apollo.BaseMutationOptions<BlockSponsorMutation, BlockSponsorMutationVariables>;
export const ContentListCountDocument = gql`
    query ContentListCount($getContentsInput: GetContentsInput!) {
  contentListCount(getContentsInput: $getContentsInput) {
    count
  }
}
    `;

/**
 * __useContentListCountQuery__
 *
 * To run a query within a React component, call `useContentListCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentListCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentListCountQuery({
 *   variables: {
 *      getContentsInput: // value for 'getContentsInput'
 *   },
 * });
 */
export function useContentListCountQuery(baseOptions: Apollo.QueryHookOptions<ContentListCountQuery, ContentListCountQueryVariables> & ({ variables: ContentListCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentListCountQuery, ContentListCountQueryVariables>(ContentListCountDocument, options);
      }
export function useContentListCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentListCountQuery, ContentListCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentListCountQuery, ContentListCountQueryVariables>(ContentListCountDocument, options);
        }
export function useContentListCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContentListCountQuery, ContentListCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentListCountQuery, ContentListCountQueryVariables>(ContentListCountDocument, options);
        }
export type ContentListCountQueryHookResult = ReturnType<typeof useContentListCountQuery>;
export type ContentListCountLazyQueryHookResult = ReturnType<typeof useContentListCountLazyQuery>;
export type ContentListCountSuspenseQueryHookResult = ReturnType<typeof useContentListCountSuspenseQuery>;
export type ContentListCountQueryResult = Apollo.QueryResult<ContentListCountQuery, ContentListCountQueryVariables>;
export const ContentOwnersListDocument = gql`
    query ContentOwnersList($feedInputData: FeedInputData!) {
  contentOwnersList(feedInputData: $feedInputData) {
    count
    list {
      id
      username
      isCompany
      contentOwnershipName
      companyName
      coverImage
      address
      physicalResidency
      verified
      disabled
      isContentOwner
      isPartner
      createdAt
    }
  }
}
    `;

/**
 * __useContentOwnersListQuery__
 *
 * To run a query within a React component, call `useContentOwnersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentOwnersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentOwnersListQuery({
 *   variables: {
 *      feedInputData: // value for 'feedInputData'
 *   },
 * });
 */
export function useContentOwnersListQuery(baseOptions: Apollo.QueryHookOptions<ContentOwnersListQuery, ContentOwnersListQueryVariables> & ({ variables: ContentOwnersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentOwnersListQuery, ContentOwnersListQueryVariables>(ContentOwnersListDocument, options);
      }
export function useContentOwnersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentOwnersListQuery, ContentOwnersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentOwnersListQuery, ContentOwnersListQueryVariables>(ContentOwnersListDocument, options);
        }
export function useContentOwnersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContentOwnersListQuery, ContentOwnersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentOwnersListQuery, ContentOwnersListQueryVariables>(ContentOwnersListDocument, options);
        }
export type ContentOwnersListQueryHookResult = ReturnType<typeof useContentOwnersListQuery>;
export type ContentOwnersListLazyQueryHookResult = ReturnType<typeof useContentOwnersListLazyQuery>;
export type ContentOwnersListSuspenseQueryHookResult = ReturnType<typeof useContentOwnersListSuspenseQuery>;
export type ContentOwnersListQueryResult = Apollo.QueryResult<ContentOwnersListQuery, ContentOwnersListQueryVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($createEventInput: CreateEventInput!) {
  createEvent(createEventInput: $createEventInput) {
    message
    status
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      createEventInput: // value for 'createEventInput'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const AddTopicToAgendaDocument = gql`
    mutation AddTopicToAgenda($addTopicInAgenda: IAddTopicInAgenda!) {
  addTopicToAgenda(addTopicInAgenda: $addTopicInAgenda) {
    message
    status
  }
}
    `;
export type AddTopicToAgendaMutationFn = Apollo.MutationFunction<AddTopicToAgendaMutation, AddTopicToAgendaMutationVariables>;

/**
 * __useAddTopicToAgendaMutation__
 *
 * To run a mutation, you first call `useAddTopicToAgendaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTopicToAgendaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTopicToAgendaMutation, { data, loading, error }] = useAddTopicToAgendaMutation({
 *   variables: {
 *      addTopicInAgenda: // value for 'addTopicInAgenda'
 *   },
 * });
 */
export function useAddTopicToAgendaMutation(baseOptions?: Apollo.MutationHookOptions<AddTopicToAgendaMutation, AddTopicToAgendaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTopicToAgendaMutation, AddTopicToAgendaMutationVariables>(AddTopicToAgendaDocument, options);
      }
export type AddTopicToAgendaMutationHookResult = ReturnType<typeof useAddTopicToAgendaMutation>;
export type AddTopicToAgendaMutationResult = Apollo.MutationResult<AddTopicToAgendaMutation>;
export type AddTopicToAgendaMutationOptions = Apollo.BaseMutationOptions<AddTopicToAgendaMutation, AddTopicToAgendaMutationVariables>;
export const DeleteSponsorGalleryImageDocument = gql`
    mutation DeleteSponsorGalleryImage($imageInput: ImageInput!) {
  deleteSponsorGalleryImage(imageInput: $imageInput) {
    message
    status
  }
}
    `;
export type DeleteSponsorGalleryImageMutationFn = Apollo.MutationFunction<DeleteSponsorGalleryImageMutation, DeleteSponsorGalleryImageMutationVariables>;

/**
 * __useDeleteSponsorGalleryImageMutation__
 *
 * To run a mutation, you first call `useDeleteSponsorGalleryImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSponsorGalleryImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSponsorGalleryImageMutation, { data, loading, error }] = useDeleteSponsorGalleryImageMutation({
 *   variables: {
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useDeleteSponsorGalleryImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSponsorGalleryImageMutation, DeleteSponsorGalleryImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSponsorGalleryImageMutation, DeleteSponsorGalleryImageMutationVariables>(DeleteSponsorGalleryImageDocument, options);
      }
export type DeleteSponsorGalleryImageMutationHookResult = ReturnType<typeof useDeleteSponsorGalleryImageMutation>;
export type DeleteSponsorGalleryImageMutationResult = Apollo.MutationResult<DeleteSponsorGalleryImageMutation>;
export type DeleteSponsorGalleryImageMutationOptions = Apollo.BaseMutationOptions<DeleteSponsorGalleryImageMutation, DeleteSponsorGalleryImageMutationVariables>;
export const DisableContentDocument = gql`
    mutation DisableContent($deleteEvent: DeleteEvent!) {
  disableContent(deleteEvent: $deleteEvent) {
    message
    status
  }
}
    `;
export type DisableContentMutationFn = Apollo.MutationFunction<DisableContentMutation, DisableContentMutationVariables>;

/**
 * __useDisableContentMutation__
 *
 * To run a mutation, you first call `useDisableContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableContentMutation, { data, loading, error }] = useDisableContentMutation({
 *   variables: {
 *      deleteEvent: // value for 'deleteEvent'
 *   },
 * });
 */
export function useDisableContentMutation(baseOptions?: Apollo.MutationHookOptions<DisableContentMutation, DisableContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableContentMutation, DisableContentMutationVariables>(DisableContentDocument, options);
      }
export type DisableContentMutationHookResult = ReturnType<typeof useDisableContentMutation>;
export type DisableContentMutationResult = Apollo.MutationResult<DisableContentMutation>;
export type DisableContentMutationOptions = Apollo.BaseMutationOptions<DisableContentMutation, DisableContentMutationVariables>;
export const EditContentDocument = gql`
    mutation EditContent($editContentInput: EditContentInput!) {
  editContent(editContentInput: $editContentInput) {
    status
    message
  }
}
    `;
export type EditContentMutationFn = Apollo.MutationFunction<EditContentMutation, EditContentMutationVariables>;

/**
 * __useEditContentMutation__
 *
 * To run a mutation, you first call `useEditContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContentMutation, { data, loading, error }] = useEditContentMutation({
 *   variables: {
 *      editContentInput: // value for 'editContentInput'
 *   },
 * });
 */
export function useEditContentMutation(baseOptions?: Apollo.MutationHookOptions<EditContentMutation, EditContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContentMutation, EditContentMutationVariables>(EditContentDocument, options);
      }
export type EditContentMutationHookResult = ReturnType<typeof useEditContentMutation>;
export type EditContentMutationResult = Apollo.MutationResult<EditContentMutation>;
export type EditContentMutationOptions = Apollo.BaseMutationOptions<EditContentMutation, EditContentMutationVariables>;
export const FilterAreasDocument = gql`
    query FilterAreas($feedInputData: FeedInputData!) {
  filterAreas(feedInputData: $feedInputData) {
    id
    country
    regionName
    districtName
    wardName
    areaName
    bandaNumber
    isActive
    areaType
  }
}
    `;

/**
 * __useFilterAreasQuery__
 *
 * To run a query within a React component, call `useFilterAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterAreasQuery({
 *   variables: {
 *      feedInputData: // value for 'feedInputData'
 *   },
 * });
 */
export function useFilterAreasQuery(baseOptions: Apollo.QueryHookOptions<FilterAreasQuery, FilterAreasQueryVariables> & ({ variables: FilterAreasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterAreasQuery, FilterAreasQueryVariables>(FilterAreasDocument, options);
      }
export function useFilterAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterAreasQuery, FilterAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterAreasQuery, FilterAreasQueryVariables>(FilterAreasDocument, options);
        }
export function useFilterAreasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FilterAreasQuery, FilterAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilterAreasQuery, FilterAreasQueryVariables>(FilterAreasDocument, options);
        }
export type FilterAreasQueryHookResult = ReturnType<typeof useFilterAreasQuery>;
export type FilterAreasLazyQueryHookResult = ReturnType<typeof useFilterAreasLazyQuery>;
export type FilterAreasSuspenseQueryHookResult = ReturnType<typeof useFilterAreasSuspenseQuery>;
export type FilterAreasQueryResult = Apollo.QueryResult<FilterAreasQuery, FilterAreasQueryVariables>;
export const ATopicDocument = gql`
    query ATopic($getTopic: GetTopic!) {
  aTopic(getTopic: $getTopic) {
    statement
    title
    description
    createdAt
    media
    topic
  }
}
    `;

/**
 * __useATopicQuery__
 *
 * To run a query within a React component, call `useATopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useATopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useATopicQuery({
 *   variables: {
 *      getTopic: // value for 'getTopic'
 *   },
 * });
 */
export function useATopicQuery(baseOptions: Apollo.QueryHookOptions<ATopicQuery, ATopicQueryVariables> & ({ variables: ATopicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ATopicQuery, ATopicQueryVariables>(ATopicDocument, options);
      }
export function useATopicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ATopicQuery, ATopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ATopicQuery, ATopicQueryVariables>(ATopicDocument, options);
        }
export function useATopicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ATopicQuery, ATopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ATopicQuery, ATopicQueryVariables>(ATopicDocument, options);
        }
export type ATopicQueryHookResult = ReturnType<typeof useATopicQuery>;
export type ATopicLazyQueryHookResult = ReturnType<typeof useATopicLazyQuery>;
export type ATopicSuspenseQueryHookResult = ReturnType<typeof useATopicSuspenseQuery>;
export type ATopicQueryResult = Apollo.QueryResult<ATopicQuery, ATopicQueryVariables>;
export const BandaListDocument = gql`
    query BandaList($feedInputData: FeedInputData!) {
  bandaList(feedInputData: $feedInputData) {
    bandaName
    ownerName
    phoneNumber
    email
    bandaCode
    district
    region
    ward
    media
    location
    address
    coverImage
    userNationalId
    capacity
    physicalResidency
    verified
    mtaa {
      nameWardCode
      name
    }
    blocked
    userId
    createdAt
    eventsFunds {
      id
      description
      startDateTime
      endDateTime
    }
    decoders
    tvSize
    id
  }
}
    `;

/**
 * __useBandaListQuery__
 *
 * To run a query within a React component, call `useBandaListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBandaListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBandaListQuery({
 *   variables: {
 *      feedInputData: // value for 'feedInputData'
 *   },
 * });
 */
export function useBandaListQuery(baseOptions: Apollo.QueryHookOptions<BandaListQuery, BandaListQueryVariables> & ({ variables: BandaListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BandaListQuery, BandaListQueryVariables>(BandaListDocument, options);
      }
export function useBandaListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BandaListQuery, BandaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BandaListQuery, BandaListQueryVariables>(BandaListDocument, options);
        }
export function useBandaListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BandaListQuery, BandaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BandaListQuery, BandaListQueryVariables>(BandaListDocument, options);
        }
export type BandaListQueryHookResult = ReturnType<typeof useBandaListQuery>;
export type BandaListLazyQueryHookResult = ReturnType<typeof useBandaListLazyQuery>;
export type BandaListSuspenseQueryHookResult = ReturnType<typeof useBandaListSuspenseQuery>;
export type BandaListQueryResult = Apollo.QueryResult<BandaListQuery, BandaListQueryVariables>;
export const GetBandaByCodeDocument = gql`
    query GetBandaByCode($feedInputData: FeedInputData!) {
  getBandaByCode(feedInputData: $feedInputData) {
    bandaName
    ownerName
    bandaCode
    media
    location
    priceHour
    currency
    district
    region
    ward
    address
    capacity
    numberOfTv
    physicalResidency
    userId
    createdAt
    eventsFunds {
      id
      title
      startDateTime
      endDateTime
      eventType
    }
    decoders
    id
  }
}
    `;

/**
 * __useGetBandaByCodeQuery__
 *
 * To run a query within a React component, call `useGetBandaByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBandaByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBandaByCodeQuery({
 *   variables: {
 *      feedInputData: // value for 'feedInputData'
 *   },
 * });
 */
export function useGetBandaByCodeQuery(baseOptions: Apollo.QueryHookOptions<GetBandaByCodeQuery, GetBandaByCodeQueryVariables> & ({ variables: GetBandaByCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBandaByCodeQuery, GetBandaByCodeQueryVariables>(GetBandaByCodeDocument, options);
      }
export function useGetBandaByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBandaByCodeQuery, GetBandaByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBandaByCodeQuery, GetBandaByCodeQueryVariables>(GetBandaByCodeDocument, options);
        }
export function useGetBandaByCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBandaByCodeQuery, GetBandaByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBandaByCodeQuery, GetBandaByCodeQueryVariables>(GetBandaByCodeDocument, options);
        }
export type GetBandaByCodeQueryHookResult = ReturnType<typeof useGetBandaByCodeQuery>;
export type GetBandaByCodeLazyQueryHookResult = ReturnType<typeof useGetBandaByCodeLazyQuery>;
export type GetBandaByCodeSuspenseQueryHookResult = ReturnType<typeof useGetBandaByCodeSuspenseQuery>;
export type GetBandaByCodeQueryResult = Apollo.QueryResult<GetBandaByCodeQuery, GetBandaByCodeQueryVariables>;
export const GetBandaByCodePromoDocument = gql`
    query GetBandaByCodePromo($feedInputPromoData: FeedInputPromoData!) {
  getBandaByCodePromo(feedInputPromoData: $feedInputPromoData) {
    bandaName
    ownerName
    bandaCode
    media
    location
    priceHour
    currency
    district
    region
    ward
    address
    capacity
    numberOfTv
    physicalResidency
    userId
    createdAt
    eventsFunds {
      id
      title
      contentId
      startDateTime
      endDateTime
      eventType
    }
    decoders
    id
  }
}
    `;

/**
 * __useGetBandaByCodePromoQuery__
 *
 * To run a query within a React component, call `useGetBandaByCodePromoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBandaByCodePromoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBandaByCodePromoQuery({
 *   variables: {
 *      feedInputPromoData: // value for 'feedInputPromoData'
 *   },
 * });
 */
export function useGetBandaByCodePromoQuery(baseOptions: Apollo.QueryHookOptions<GetBandaByCodePromoQuery, GetBandaByCodePromoQueryVariables> & ({ variables: GetBandaByCodePromoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBandaByCodePromoQuery, GetBandaByCodePromoQueryVariables>(GetBandaByCodePromoDocument, options);
      }
export function useGetBandaByCodePromoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBandaByCodePromoQuery, GetBandaByCodePromoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBandaByCodePromoQuery, GetBandaByCodePromoQueryVariables>(GetBandaByCodePromoDocument, options);
        }
export function useGetBandaByCodePromoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBandaByCodePromoQuery, GetBandaByCodePromoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBandaByCodePromoQuery, GetBandaByCodePromoQueryVariables>(GetBandaByCodePromoDocument, options);
        }
export type GetBandaByCodePromoQueryHookResult = ReturnType<typeof useGetBandaByCodePromoQuery>;
export type GetBandaByCodePromoLazyQueryHookResult = ReturnType<typeof useGetBandaByCodePromoLazyQuery>;
export type GetBandaByCodePromoSuspenseQueryHookResult = ReturnType<typeof useGetBandaByCodePromoSuspenseQuery>;
export type GetBandaByCodePromoQueryResult = Apollo.QueryResult<GetBandaByCodePromoQuery, GetBandaByCodePromoQueryVariables>;
export const GetBandaDocument = gql`
    query GetBanda($findBandaumizaInput: FindBandaumizaInput!) {
  getBanda(findBandaumizaInput: $findBandaumizaInput) {
    bandaName
    ownerName
    description
    phoneNumber
    email
    bandaCode
    media
    coverImage
    location
    priceHour
    currency
    address
    userNationalId
    bandaSize
    gallery
    capacity
    numberOfTv
    physicalResidency
    verified
    blocked
    userId
    mtaa {
      nameWardCode
      name
    }
    createdAt
    district
    region
    ward
    mtaaName
    drinks
    food
    projector
    wifi
    generator
    vikalioKutoka
    laptop
    airConditioner
    feni
    eventsFunds {
      id
      description
      title
      createdAt
      scheduleData
      eventType
      contentId
      fundedBy
      sponsor {
        id
        isCompany
        coverImage
        sponsorName
        companyName
      }
      sponsorId
      startDateTime
      endDateTime
      content {
        id
        author {
          id
          username
        }
        categories {
          name
        }
      }
    }
    decoders
    tvSize
    id
  }
}
    `;

/**
 * __useGetBandaQuery__
 *
 * To run a query within a React component, call `useGetBandaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBandaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBandaQuery({
 *   variables: {
 *      findBandaumizaInput: // value for 'findBandaumizaInput'
 *   },
 * });
 */
export function useGetBandaQuery(baseOptions: Apollo.QueryHookOptions<GetBandaQuery, GetBandaQueryVariables> & ({ variables: GetBandaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBandaQuery, GetBandaQueryVariables>(GetBandaDocument, options);
      }
export function useGetBandaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBandaQuery, GetBandaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBandaQuery, GetBandaQueryVariables>(GetBandaDocument, options);
        }
export function useGetBandaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBandaQuery, GetBandaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBandaQuery, GetBandaQueryVariables>(GetBandaDocument, options);
        }
export type GetBandaQueryHookResult = ReturnType<typeof useGetBandaQuery>;
export type GetBandaLazyQueryHookResult = ReturnType<typeof useGetBandaLazyQuery>;
export type GetBandaSuspenseQueryHookResult = ReturnType<typeof useGetBandaSuspenseQuery>;
export type GetBandaQueryResult = Apollo.QueryResult<GetBandaQuery, GetBandaQueryVariables>;
export const GetBandaFundedDocument = gql`
    query GetBandaFunded($getEventsInput: GetEventsInput!) {
  getBandaFunded(getEventsInput: $getEventsInput) {
    title
    createdAt
    published
    eventIdForPromo
    promoId
    currency
    contentId
    amount
    invoiceId
    bandaId
    sponsorId
    authorId
    breakDurationInMins
    breakFrequency
    eventType
    startDateTime
    endDateTime
    content {
      id
      categories {
        name
      }
      languages
    }
    id
    userId
    description
  }
}
    `;

/**
 * __useGetBandaFundedQuery__
 *
 * To run a query within a React component, call `useGetBandaFundedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBandaFundedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBandaFundedQuery({
 *   variables: {
 *      getEventsInput: // value for 'getEventsInput'
 *   },
 * });
 */
export function useGetBandaFundedQuery(baseOptions: Apollo.QueryHookOptions<GetBandaFundedQuery, GetBandaFundedQueryVariables> & ({ variables: GetBandaFundedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBandaFundedQuery, GetBandaFundedQueryVariables>(GetBandaFundedDocument, options);
      }
export function useGetBandaFundedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBandaFundedQuery, GetBandaFundedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBandaFundedQuery, GetBandaFundedQueryVariables>(GetBandaFundedDocument, options);
        }
export function useGetBandaFundedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBandaFundedQuery, GetBandaFundedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBandaFundedQuery, GetBandaFundedQueryVariables>(GetBandaFundedDocument, options);
        }
export type GetBandaFundedQueryHookResult = ReturnType<typeof useGetBandaFundedQuery>;
export type GetBandaFundedLazyQueryHookResult = ReturnType<typeof useGetBandaFundedLazyQuery>;
export type GetBandaFundedSuspenseQueryHookResult = ReturnType<typeof useGetBandaFundedSuspenseQuery>;
export type GetBandaFundedQueryResult = Apollo.QueryResult<GetBandaFundedQuery, GetBandaFundedQueryVariables>;
export const GetContentDocument = gql`
    query GetContent($getContentInput: GetContentInput!) {
  getContent(getContentInput: $getContentInput) {
    title
    media
    link
    coverImage
    fundedBy
    createdAt
    duration
    amount
    verifiedBy
    currency
    published
    languages
    startDateTime
    endDateTime
    author {
      id
      username
    }
    categories {
      name
    }
    id
    userId
    description
  }
}
    `;

/**
 * __useGetContentQuery__
 *
 * To run a query within a React component, call `useGetContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentQuery({
 *   variables: {
 *      getContentInput: // value for 'getContentInput'
 *   },
 * });
 */
export function useGetContentQuery(baseOptions: Apollo.QueryHookOptions<GetContentQuery, GetContentQueryVariables> & ({ variables: GetContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
      }
export function useGetContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentQuery, GetContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
        }
export function useGetContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentQuery, GetContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
        }
export type GetContentQueryHookResult = ReturnType<typeof useGetContentQuery>;
export type GetContentLazyQueryHookResult = ReturnType<typeof useGetContentLazyQuery>;
export type GetContentSuspenseQueryHookResult = ReturnType<typeof useGetContentSuspenseQuery>;
export type GetContentQueryResult = Apollo.QueryResult<GetContentQuery, GetContentQueryVariables>;
export const MyContentEventsListDocument = gql`
    query MyContentEventsList($getMyBandaEventsInput: GetContentInput!) {
  myContentEventsList(getMyBandaEventsInput: $getMyBandaEventsInput) {
    title
    createdAt
    published
    bandaCode
    startDateTime
    endDateTime
    sponsor {
      id
      isCompany
      sponsorName
      coverImage
      companyName
    }
    id
    userId
    description
    banda {
      id
      bandaName
      bandaCode
      coverImage
      address
      district
      region
      ward
      mtaaName
      mtaa {
        name
        regionData {
          country
          regionName
          districtName
          wardName
          areaName
        }
      }
      physicalResidency
      capacity
    }
  }
}
    `;

/**
 * __useMyContentEventsListQuery__
 *
 * To run a query within a React component, call `useMyContentEventsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyContentEventsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyContentEventsListQuery({
 *   variables: {
 *      getMyBandaEventsInput: // value for 'getMyBandaEventsInput'
 *   },
 * });
 */
export function useMyContentEventsListQuery(baseOptions: Apollo.QueryHookOptions<MyContentEventsListQuery, MyContentEventsListQueryVariables> & ({ variables: MyContentEventsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyContentEventsListQuery, MyContentEventsListQueryVariables>(MyContentEventsListDocument, options);
      }
export function useMyContentEventsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyContentEventsListQuery, MyContentEventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyContentEventsListQuery, MyContentEventsListQueryVariables>(MyContentEventsListDocument, options);
        }
export function useMyContentEventsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyContentEventsListQuery, MyContentEventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyContentEventsListQuery, MyContentEventsListQueryVariables>(MyContentEventsListDocument, options);
        }
export type MyContentEventsListQueryHookResult = ReturnType<typeof useMyContentEventsListQuery>;
export type MyContentEventsListLazyQueryHookResult = ReturnType<typeof useMyContentEventsListLazyQuery>;
export type MyContentEventsListSuspenseQueryHookResult = ReturnType<typeof useMyContentEventsListSuspenseQuery>;
export type MyContentEventsListQueryResult = Apollo.QueryResult<MyContentEventsListQuery, MyContentEventsListQueryVariables>;
export const ContentListDocument = gql`
    query ContentList($getContentsInput: GetContentsInput!) {
  contentList(getContentsInput: $getContentsInput) {
    count
    list {
      title
      media
      link
      coverImage
      fundedBy
      createdAt
      amount
      currency
      published
      languages
      verifiedBy
      startDateTime
      endDateTime
      events {
        id
      }
      author {
        id
        username
        coverImage
      }
      id
      userId
      description
    }
  }
}
    `;

/**
 * __useContentListQuery__
 *
 * To run a query within a React component, call `useContentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentListQuery({
 *   variables: {
 *      getContentsInput: // value for 'getContentsInput'
 *   },
 * });
 */
export function useContentListQuery(baseOptions: Apollo.QueryHookOptions<ContentListQuery, ContentListQueryVariables> & ({ variables: ContentListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentListQuery, ContentListQueryVariables>(ContentListDocument, options);
      }
export function useContentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentListQuery, ContentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentListQuery, ContentListQueryVariables>(ContentListDocument, options);
        }
export function useContentListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContentListQuery, ContentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentListQuery, ContentListQueryVariables>(ContentListDocument, options);
        }
export type ContentListQueryHookResult = ReturnType<typeof useContentListQuery>;
export type ContentListLazyQueryHookResult = ReturnType<typeof useContentListLazyQuery>;
export type ContentListSuspenseQueryHookResult = ReturnType<typeof useContentListSuspenseQuery>;
export type ContentListQueryResult = Apollo.QueryResult<ContentListQuery, ContentListQueryVariables>;
export const GetEventDocument = gql`
    query GetEvent($getEventInput: GetEventInput!) {
  getEvent(getEventInput: $getEventInput) {
    title
    createdAt
    published
    eventIdForPromo
    promoId
    currency
    contentId
    orderSteps
    amount
    invoiceId
    bandaId
    sponsorId
    authorId
    breakDurationInMins
    breakFrequency
    eventType
    startDateTime
    endDateTime
    content {
      id
      categories {
        name
      }
      languages
    }
    id
    userId
    description
  }
}
    `;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      getEventInput: // value for 'getEventInput'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables> & ({ variables: GetEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export function useGetEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventSuspenseQueryHookResult = ReturnType<typeof useGetEventSuspenseQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const EventsListDocument = gql`
    query EventsList($getEventsInput: GetEventsInput!) {
  eventsList(getEventsInput: $getEventsInput) {
    title
    createdAt
    published
    eventIdForPromo
    promoId
    currency
    contentId
    amount
    orderSteps
    invoiceId
    bandaId
    sponsorId
    authorId
    breakDurationInMins
    breakFrequency
    eventType
    startDateTime
    endDateTime
    content {
      id
      categories {
        name
      }
      languages
      coverImage
    }
    id
    userId
    coverImage
    description
  }
}
    `;

/**
 * __useEventsListQuery__
 *
 * To run a query within a React component, call `useEventsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsListQuery({
 *   variables: {
 *      getEventsInput: // value for 'getEventsInput'
 *   },
 * });
 */
export function useEventsListQuery(baseOptions: Apollo.QueryHookOptions<EventsListQuery, EventsListQueryVariables> & ({ variables: EventsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsListQuery, EventsListQueryVariables>(EventsListDocument, options);
      }
export function useEventsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsListQuery, EventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsListQuery, EventsListQueryVariables>(EventsListDocument, options);
        }
export function useEventsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventsListQuery, EventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsListQuery, EventsListQueryVariables>(EventsListDocument, options);
        }
export type EventsListQueryHookResult = ReturnType<typeof useEventsListQuery>;
export type EventsListLazyQueryHookResult = ReturnType<typeof useEventsListLazyQuery>;
export type EventsListSuspenseQueryHookResult = ReturnType<typeof useEventsListSuspenseQuery>;
export type EventsListQueryResult = Apollo.QueryResult<EventsListQuery, EventsListQueryVariables>;
export const GetBandaReservationsDocument = gql`
    query GetBandaReservations($getEventsInput: GetEventsInput!) {
  getBandaReservations(getEventsInput: $getEventsInput) {
    title
    createdAt
    published
    eventIdForPromo
    promoId
    currency
    contentId
    amount
    invoiceId
    bandaId
    sponsorId
    authorId
    breakDurationInMins
    breakFrequency
    eventType
    startDateTime
    endDateTime
    event {
      id
      title
    }
    id
    userId
    description
  }
}
    `;

/**
 * __useGetBandaReservationsQuery__
 *
 * To run a query within a React component, call `useGetBandaReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBandaReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBandaReservationsQuery({
 *   variables: {
 *      getEventsInput: // value for 'getEventsInput'
 *   },
 * });
 */
export function useGetBandaReservationsQuery(baseOptions: Apollo.QueryHookOptions<GetBandaReservationsQuery, GetBandaReservationsQueryVariables> & ({ variables: GetBandaReservationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBandaReservationsQuery, GetBandaReservationsQueryVariables>(GetBandaReservationsDocument, options);
      }
export function useGetBandaReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBandaReservationsQuery, GetBandaReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBandaReservationsQuery, GetBandaReservationsQueryVariables>(GetBandaReservationsDocument, options);
        }
export function useGetBandaReservationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBandaReservationsQuery, GetBandaReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBandaReservationsQuery, GetBandaReservationsQueryVariables>(GetBandaReservationsDocument, options);
        }
export type GetBandaReservationsQueryHookResult = ReturnType<typeof useGetBandaReservationsQuery>;
export type GetBandaReservationsLazyQueryHookResult = ReturnType<typeof useGetBandaReservationsLazyQuery>;
export type GetBandaReservationsSuspenseQueryHookResult = ReturnType<typeof useGetBandaReservationsSuspenseQuery>;
export type GetBandaReservationsQueryResult = Apollo.QueryResult<GetBandaReservationsQuery, GetBandaReservationsQueryVariables>;
export const GetMtaaDocument = gql`
    query GetMtaa($mtaaInput: MtaaInput!) {
  getMtaa(mtaaInput: $mtaaInput) {
    id
    name
    Population
    kaya
    Women
    Men
    Vijana
    Watoto
    wazee
    Attachments
    Details
    mwenyekiti
    watendaji
    mawasilianoMwenyekiti
    wardPostCode
    regionData {
      id
    }
    ward {
      id
      name
      districtData {
        name
        regionData {
          name
        }
      }
    }
    regionId
    wardId
    createdAt
    banda {
      id
      bandaCode
    }
    jembe {
      id
    }
    users {
      id
    }
    matukio {
      id
    }
    wananchi {
      id
    }
  }
}
    `;

/**
 * __useGetMtaaQuery__
 *
 * To run a query within a React component, call `useGetMtaaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMtaaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMtaaQuery({
 *   variables: {
 *      mtaaInput: // value for 'mtaaInput'
 *   },
 * });
 */
export function useGetMtaaQuery(baseOptions: Apollo.QueryHookOptions<GetMtaaQuery, GetMtaaQueryVariables> & ({ variables: GetMtaaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMtaaQuery, GetMtaaQueryVariables>(GetMtaaDocument, options);
      }
export function useGetMtaaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMtaaQuery, GetMtaaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMtaaQuery, GetMtaaQueryVariables>(GetMtaaDocument, options);
        }
export function useGetMtaaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMtaaQuery, GetMtaaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMtaaQuery, GetMtaaQueryVariables>(GetMtaaDocument, options);
        }
export type GetMtaaQueryHookResult = ReturnType<typeof useGetMtaaQuery>;
export type GetMtaaLazyQueryHookResult = ReturnType<typeof useGetMtaaLazyQuery>;
export type GetMtaaSuspenseQueryHookResult = ReturnType<typeof useGetMtaaSuspenseQuery>;
export type GetMtaaQueryResult = Apollo.QueryResult<GetMtaaQuery, GetMtaaQueryVariables>;
export const MyBandaEventsListDocument = gql`
    query MyBandaEventsList($getMyBandaEventsInput: GetContentInput!) {
  myBandaEventsList(getMyBandaEventsInput: $getMyBandaEventsInput) {
    title
    createdAt
    published
    eventIdForPromo
    promoId
    currency
    contentId
    bandaCode
    amount
    invoiceId
    bandaId
    sponsorId
    authorId
    breakDurationInMins
    breakFrequency
    eventType
    startDateTime
    endDateTime
    content {
      id
      categories {
        name
      }
      languages
    }
    id
    userId
    description
  }
}
    `;

/**
 * __useMyBandaEventsListQuery__
 *
 * To run a query within a React component, call `useMyBandaEventsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBandaEventsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBandaEventsListQuery({
 *   variables: {
 *      getMyBandaEventsInput: // value for 'getMyBandaEventsInput'
 *   },
 * });
 */
export function useMyBandaEventsListQuery(baseOptions: Apollo.QueryHookOptions<MyBandaEventsListQuery, MyBandaEventsListQueryVariables> & ({ variables: MyBandaEventsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyBandaEventsListQuery, MyBandaEventsListQueryVariables>(MyBandaEventsListDocument, options);
      }
export function useMyBandaEventsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyBandaEventsListQuery, MyBandaEventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyBandaEventsListQuery, MyBandaEventsListQueryVariables>(MyBandaEventsListDocument, options);
        }
export function useMyBandaEventsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyBandaEventsListQuery, MyBandaEventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyBandaEventsListQuery, MyBandaEventsListQueryVariables>(MyBandaEventsListDocument, options);
        }
export type MyBandaEventsListQueryHookResult = ReturnType<typeof useMyBandaEventsListQuery>;
export type MyBandaEventsListLazyQueryHookResult = ReturnType<typeof useMyBandaEventsListLazyQuery>;
export type MyBandaEventsListSuspenseQueryHookResult = ReturnType<typeof useMyBandaEventsListSuspenseQuery>;
export type MyBandaEventsListQueryResult = Apollo.QueryResult<MyBandaEventsListQuery, MyBandaEventsListQueryVariables>;
export const MyBandaEventsPrivateDocument = gql`
    query MyBandaEventsPrivate($getMyBandaInput: GetMyBandaInput!) {
  myBandaEventsPrivate(getMyBandaInput: $getMyBandaInput) {
    title
    createdAt
    published
    id
    description
  }
}
    `;

/**
 * __useMyBandaEventsPrivateQuery__
 *
 * To run a query within a React component, call `useMyBandaEventsPrivateQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBandaEventsPrivateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBandaEventsPrivateQuery({
 *   variables: {
 *      getMyBandaInput: // value for 'getMyBandaInput'
 *   },
 * });
 */
export function useMyBandaEventsPrivateQuery(baseOptions: Apollo.QueryHookOptions<MyBandaEventsPrivateQuery, MyBandaEventsPrivateQueryVariables> & ({ variables: MyBandaEventsPrivateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyBandaEventsPrivateQuery, MyBandaEventsPrivateQueryVariables>(MyBandaEventsPrivateDocument, options);
      }
export function useMyBandaEventsPrivateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyBandaEventsPrivateQuery, MyBandaEventsPrivateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyBandaEventsPrivateQuery, MyBandaEventsPrivateQueryVariables>(MyBandaEventsPrivateDocument, options);
        }
export function useMyBandaEventsPrivateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyBandaEventsPrivateQuery, MyBandaEventsPrivateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyBandaEventsPrivateQuery, MyBandaEventsPrivateQueryVariables>(MyBandaEventsPrivateDocument, options);
        }
export type MyBandaEventsPrivateQueryHookResult = ReturnType<typeof useMyBandaEventsPrivateQuery>;
export type MyBandaEventsPrivateLazyQueryHookResult = ReturnType<typeof useMyBandaEventsPrivateLazyQuery>;
export type MyBandaEventsPrivateSuspenseQueryHookResult = ReturnType<typeof useMyBandaEventsPrivateSuspenseQuery>;
export type MyBandaEventsPrivateQueryResult = Apollo.QueryResult<MyBandaEventsPrivateQuery, MyBandaEventsPrivateQueryVariables>;
export const MyContentsListDocument = gql`
    query MyContentsList($getMyContentInput: GetMyContentInput!) {
  myContentsList(getMyContentInput: $getMyContentInput) {
    title
    media
    link
    coverImage
    amount
    currency
    fundedBy
    createdAt
    published
    languages
    author {
      id
      username
    }
    id
    userId
    description
  }
}
    `;

/**
 * __useMyContentsListQuery__
 *
 * To run a query within a React component, call `useMyContentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyContentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyContentsListQuery({
 *   variables: {
 *      getMyContentInput: // value for 'getMyContentInput'
 *   },
 * });
 */
export function useMyContentsListQuery(baseOptions: Apollo.QueryHookOptions<MyContentsListQuery, MyContentsListQueryVariables> & ({ variables: MyContentsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyContentsListQuery, MyContentsListQueryVariables>(MyContentsListDocument, options);
      }
export function useMyContentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyContentsListQuery, MyContentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyContentsListQuery, MyContentsListQueryVariables>(MyContentsListDocument, options);
        }
export function useMyContentsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyContentsListQuery, MyContentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyContentsListQuery, MyContentsListQueryVariables>(MyContentsListDocument, options);
        }
export type MyContentsListQueryHookResult = ReturnType<typeof useMyContentsListQuery>;
export type MyContentsListLazyQueryHookResult = ReturnType<typeof useMyContentsListLazyQuery>;
export type MyContentsListSuspenseQueryHookResult = ReturnType<typeof useMyContentsListSuspenseQuery>;
export type MyContentsListQueryResult = Apollo.QueryResult<MyContentsListQuery, MyContentsListQueryVariables>;
export const MyEventsListDocument = gql`
    query MyEventsList($getContentInput: GetContentInput!) {
  myEventsList(getContentInput: $getContentInput) {
    title
    createdAt
    published
    contentId
    amount
    bandaCode
    orderSteps
    invoiceId
    bandaId
    banda {
      bandaName
      bandaCode
    }
    sponsorId
    orderSteps
    eventType
    orderType
    startDateTime
    endDateTime
    id
    userId
    description
  }
}
    `;

/**
 * __useMyEventsListQuery__
 *
 * To run a query within a React component, call `useMyEventsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEventsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEventsListQuery({
 *   variables: {
 *      getContentInput: // value for 'getContentInput'
 *   },
 * });
 */
export function useMyEventsListQuery(baseOptions: Apollo.QueryHookOptions<MyEventsListQuery, MyEventsListQueryVariables> & ({ variables: MyEventsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEventsListQuery, MyEventsListQueryVariables>(MyEventsListDocument, options);
      }
export function useMyEventsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEventsListQuery, MyEventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEventsListQuery, MyEventsListQueryVariables>(MyEventsListDocument, options);
        }
export function useMyEventsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyEventsListQuery, MyEventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyEventsListQuery, MyEventsListQueryVariables>(MyEventsListDocument, options);
        }
export type MyEventsListQueryHookResult = ReturnType<typeof useMyEventsListQuery>;
export type MyEventsListLazyQueryHookResult = ReturnType<typeof useMyEventsListLazyQuery>;
export type MyEventsListSuspenseQueryHookResult = ReturnType<typeof useMyEventsListSuspenseQuery>;
export type MyEventsListQueryResult = Apollo.QueryResult<MyEventsListQuery, MyEventsListQueryVariables>;
export const MyNotificationsDocument = gql`
    query MyNotifications($getMyContentInput: GetMyContentInput!) {
  myNotifications(getMyContentInput: $getMyContentInput) {
    id
    description
    title
    notificationType
    media
    isSeen
    createdAt
  }
}
    `;

/**
 * __useMyNotificationsQuery__
 *
 * To run a query within a React component, call `useMyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyNotificationsQuery({
 *   variables: {
 *      getMyContentInput: // value for 'getMyContentInput'
 *   },
 * });
 */
export function useMyNotificationsQuery(baseOptions: Apollo.QueryHookOptions<MyNotificationsQuery, MyNotificationsQueryVariables> & ({ variables: MyNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyNotificationsQuery, MyNotificationsQueryVariables>(MyNotificationsDocument, options);
      }
export function useMyNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyNotificationsQuery, MyNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyNotificationsQuery, MyNotificationsQueryVariables>(MyNotificationsDocument, options);
        }
export function useMyNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyNotificationsQuery, MyNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyNotificationsQuery, MyNotificationsQueryVariables>(MyNotificationsDocument, options);
        }
export type MyNotificationsQueryHookResult = ReturnType<typeof useMyNotificationsQuery>;
export type MyNotificationsLazyQueryHookResult = ReturnType<typeof useMyNotificationsLazyQuery>;
export type MyNotificationsSuspenseQueryHookResult = ReturnType<typeof useMyNotificationsSuspenseQuery>;
export type MyNotificationsQueryResult = Apollo.QueryResult<MyNotificationsQuery, MyNotificationsQueryVariables>;
export const AgendaTopicsListDocument = gql`
    query AgendaTopicsList($getTopicInAgendaData: GetTopicInAgendaData!) {
  agendaTopicsList(getTopicInAgendaData: $getTopicInAgendaData) {
    id
    title
    statement
    dateOfEvent
    createdAt
    posts {
      id
      title
      topic
      statement
      dateOfEvent
      createdAt
    }
  }
}
    `;

/**
 * __useAgendaTopicsListQuery__
 *
 * To run a query within a React component, call `useAgendaTopicsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendaTopicsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendaTopicsListQuery({
 *   variables: {
 *      getTopicInAgendaData: // value for 'getTopicInAgendaData'
 *   },
 * });
 */
export function useAgendaTopicsListQuery(baseOptions: Apollo.QueryHookOptions<AgendaTopicsListQuery, AgendaTopicsListQueryVariables> & ({ variables: AgendaTopicsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgendaTopicsListQuery, AgendaTopicsListQueryVariables>(AgendaTopicsListDocument, options);
      }
export function useAgendaTopicsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgendaTopicsListQuery, AgendaTopicsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgendaTopicsListQuery, AgendaTopicsListQueryVariables>(AgendaTopicsListDocument, options);
        }
export function useAgendaTopicsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgendaTopicsListQuery, AgendaTopicsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgendaTopicsListQuery, AgendaTopicsListQueryVariables>(AgendaTopicsListDocument, options);
        }
export type AgendaTopicsListQueryHookResult = ReturnType<typeof useAgendaTopicsListQuery>;
export type AgendaTopicsListLazyQueryHookResult = ReturnType<typeof useAgendaTopicsListLazyQuery>;
export type AgendaTopicsListSuspenseQueryHookResult = ReturnType<typeof useAgendaTopicsListSuspenseQuery>;
export type AgendaTopicsListQueryResult = Apollo.QueryResult<AgendaTopicsListQuery, AgendaTopicsListQueryVariables>;
export const SponsorEventsListDocument = gql`
    query SponsorEventsList($getContentInput: GetContentInput!) {
  sponsorEventsList(getContentInput: $getContentInput) {
    title
    createdAt
    published
    eventIdForPromo
    promoId
    currency
    contentId
    amount
    orderSteps
    invoiceId
    bandaId
    sponsorId
    authorId
    breakDurationInMins
    breakFrequency
    eventType
    startDateTime
    endDateTime
    banda {
      bandaCode
      bandaName
    }
    content {
      id
      coverImage
      author {
        id
        username
      }
      categories {
        name
      }
      languages
    }
    id
    userId
    description
  }
}
    `;

/**
 * __useSponsorEventsListQuery__
 *
 * To run a query within a React component, call `useSponsorEventsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSponsorEventsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsorEventsListQuery({
 *   variables: {
 *      getContentInput: // value for 'getContentInput'
 *   },
 * });
 */
export function useSponsorEventsListQuery(baseOptions: Apollo.QueryHookOptions<SponsorEventsListQuery, SponsorEventsListQueryVariables> & ({ variables: SponsorEventsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SponsorEventsListQuery, SponsorEventsListQueryVariables>(SponsorEventsListDocument, options);
      }
export function useSponsorEventsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SponsorEventsListQuery, SponsorEventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SponsorEventsListQuery, SponsorEventsListQueryVariables>(SponsorEventsListDocument, options);
        }
export function useSponsorEventsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SponsorEventsListQuery, SponsorEventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SponsorEventsListQuery, SponsorEventsListQueryVariables>(SponsorEventsListDocument, options);
        }
export type SponsorEventsListQueryHookResult = ReturnType<typeof useSponsorEventsListQuery>;
export type SponsorEventsListLazyQueryHookResult = ReturnType<typeof useSponsorEventsListLazyQuery>;
export type SponsorEventsListSuspenseQueryHookResult = ReturnType<typeof useSponsorEventsListSuspenseQuery>;
export type SponsorEventsListQueryResult = Apollo.QueryResult<SponsorEventsListQuery, SponsorEventsListQueryVariables>;
export const CheckSportsListDocument = gql`
    query CheckSportsList($getSportsInput: GetSportsInput!) {
  checkSportsList(getSportsInput: $getSportsInput) {
    title
    media
    link
    coverImage
    fundedBy
    createdAt
    published
    languages
    startDateTime
    endDateTime
    author {
      id
      username
    }
    id
    userId
    description
  }
}
    `;

/**
 * __useCheckSportsListQuery__
 *
 * To run a query within a React component, call `useCheckSportsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSportsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSportsListQuery({
 *   variables: {
 *      getSportsInput: // value for 'getSportsInput'
 *   },
 * });
 */
export function useCheckSportsListQuery(baseOptions: Apollo.QueryHookOptions<CheckSportsListQuery, CheckSportsListQueryVariables> & ({ variables: CheckSportsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSportsListQuery, CheckSportsListQueryVariables>(CheckSportsListDocument, options);
      }
export function useCheckSportsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSportsListQuery, CheckSportsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSportsListQuery, CheckSportsListQueryVariables>(CheckSportsListDocument, options);
        }
export function useCheckSportsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckSportsListQuery, CheckSportsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckSportsListQuery, CheckSportsListQueryVariables>(CheckSportsListDocument, options);
        }
export type CheckSportsListQueryHookResult = ReturnType<typeof useCheckSportsListQuery>;
export type CheckSportsListLazyQueryHookResult = ReturnType<typeof useCheckSportsListLazyQuery>;
export type CheckSportsListSuspenseQueryHookResult = ReturnType<typeof useCheckSportsListSuspenseQuery>;
export type CheckSportsListQueryResult = Apollo.QueryResult<CheckSportsListQuery, CheckSportsListQueryVariables>;
export const LoginMobileDocument = gql`
    mutation LoginMobile($authLoginReg: AuthLoginReg!) {
  loginMobile(authLoginReg: $authLoginReg) {
    access_token
    refresh_token
    account_status
    log
  }
}
    `;
export type LoginMobileMutationFn = Apollo.MutationFunction<LoginMobileMutation, LoginMobileMutationVariables>;

/**
 * __useLoginMobileMutation__
 *
 * To run a mutation, you first call `useLoginMobileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMobileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMobileMutation, { data, loading, error }] = useLoginMobileMutation({
 *   variables: {
 *      authLoginReg: // value for 'authLoginReg'
 *   },
 * });
 */
export function useLoginMobileMutation(baseOptions?: Apollo.MutationHookOptions<LoginMobileMutation, LoginMobileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMobileMutation, LoginMobileMutationVariables>(LoginMobileDocument, options);
      }
export type LoginMobileMutationHookResult = ReturnType<typeof useLoginMobileMutation>;
export type LoginMobileMutationResult = Apollo.MutationResult<LoginMobileMutation>;
export type LoginMobileMutationOptions = Apollo.BaseMutationOptions<LoginMobileMutation, LoginMobileMutationVariables>;
export const LoginBandaDocument = gql`
    mutation LoginBanda($authLoginReg: AuthLoginReg!) {
  loginBanda(authLoginReg: $authLoginReg) {
    access_token
    refresh_token
    account_status
    log
  }
}
    `;
export type LoginBandaMutationFn = Apollo.MutationFunction<LoginBandaMutation, LoginBandaMutationVariables>;

/**
 * __useLoginBandaMutation__
 *
 * To run a mutation, you first call `useLoginBandaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginBandaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginBandaMutation, { data, loading, error }] = useLoginBandaMutation({
 *   variables: {
 *      authLoginReg: // value for 'authLoginReg'
 *   },
 * });
 */
export function useLoginBandaMutation(baseOptions?: Apollo.MutationHookOptions<LoginBandaMutation, LoginBandaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginBandaMutation, LoginBandaMutationVariables>(LoginBandaDocument, options);
      }
export type LoginBandaMutationHookResult = ReturnType<typeof useLoginBandaMutation>;
export type LoginBandaMutationResult = Apollo.MutationResult<LoginBandaMutation>;
export type LoginBandaMutationOptions = Apollo.BaseMutationOptions<LoginBandaMutation, LoginBandaMutationVariables>;
export const LogoutMobileDocument = gql`
    mutation LogoutMobile($logoutAuthInput: LogoutAuthInput) {
  logoutMobile(logoutAuthInput: $logoutAuthInput) {
    log
    msg
    tokenVersion
  }
}
    `;
export type LogoutMobileMutationFn = Apollo.MutationFunction<LogoutMobileMutation, LogoutMobileMutationVariables>;

/**
 * __useLogoutMobileMutation__
 *
 * To run a mutation, you first call `useLogoutMobileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMobileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMobileMutation, { data, loading, error }] = useLogoutMobileMutation({
 *   variables: {
 *      logoutAuthInput: // value for 'logoutAuthInput'
 *   },
 * });
 */
export function useLogoutMobileMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMobileMutation, LogoutMobileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMobileMutation, LogoutMobileMutationVariables>(LogoutMobileDocument, options);
      }
export type LogoutMobileMutationHookResult = ReturnType<typeof useLogoutMobileMutation>;
export type LogoutMobileMutationResult = Apollo.MutationResult<LogoutMobileMutation>;
export type LogoutMobileMutationOptions = Apollo.BaseMutationOptions<LogoutMobileMutation, LogoutMobileMutationVariables>;
export const MyBandaDocument = gql`
    query MyBanda($getMyBandaInput: GetMyBandaInput!) {
  myBanda(getMyBandaInput: $getMyBandaInput) {
    bandaName
    ownerName
    description
    phoneNumber
    coverImage
    email
    bandaCode
    district
    region
    ward
    media
    location
    gallery
    mtaa {
      nameWardCode
      name
    }
    address
    userNationalId
    capacity
    numberOfTv
    physicalResidency
    verified
    blocked
    userId
    createdAt
    addsPromo {
      id
    }
    eventsFunds {
      id
      description
      startDateTime
      endDateTime
    }
    decoders
    id
  }
}
    `;

/**
 * __useMyBandaQuery__
 *
 * To run a query within a React component, call `useMyBandaQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBandaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBandaQuery({
 *   variables: {
 *      getMyBandaInput: // value for 'getMyBandaInput'
 *   },
 * });
 */
export function useMyBandaQuery(baseOptions: Apollo.QueryHookOptions<MyBandaQuery, MyBandaQueryVariables> & ({ variables: MyBandaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyBandaQuery, MyBandaQueryVariables>(MyBandaDocument, options);
      }
export function useMyBandaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyBandaQuery, MyBandaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyBandaQuery, MyBandaQueryVariables>(MyBandaDocument, options);
        }
export function useMyBandaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyBandaQuery, MyBandaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyBandaQuery, MyBandaQueryVariables>(MyBandaDocument, options);
        }
export type MyBandaQueryHookResult = ReturnType<typeof useMyBandaQuery>;
export type MyBandaLazyQueryHookResult = ReturnType<typeof useMyBandaLazyQuery>;
export type MyBandaSuspenseQueryHookResult = ReturnType<typeof useMyBandaSuspenseQuery>;
export type MyBandaQueryResult = Apollo.QueryResult<MyBandaQuery, MyBandaQueryVariables>;
export const MyPaymentCartDocument = gql`
    query MyPaymentCart($ordersInput: OrdersInput!) {
  myPaymentCart(ordersInput: $ordersInput) {
    id
    invoiceId
    closed
    activated
    orderSteps
    sponsor {
      id
    }
    sponsorId
    userId
    totalAmount
    currency
    billingSource
    createdAt
    carts {
      id
      contentId
      promoId
      closed
      activated
      isPromo
      totalAmount
      invoiceId
      currency
      sponsor {
        id
        sponsorName
        companyName
      }
      sponsorId
      userId
      orders {
        id
      }
      bucketFund {
        id
        contentName
        currency
        specifiedArea
        amount
        frequency
        isPromoted
        orderType
      }
      promoBucket {
        id
        AddName
        currency
        specifiedArea
        amount
        orderType
        frequency
        isPromoted
      }
      events {
        id
        title
        currency
        bandaCode
        orderType
        amount
        frequency
        isPromoted
      }
      promoEvents {
        id
        title
        currency
        bandaCode
        orderType
        frequency
        isPromoted
        amount
      }
      createdAt
    }
  }
}
    `;

/**
 * __useMyPaymentCartQuery__
 *
 * To run a query within a React component, call `useMyPaymentCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPaymentCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPaymentCartQuery({
 *   variables: {
 *      ordersInput: // value for 'ordersInput'
 *   },
 * });
 */
export function useMyPaymentCartQuery(baseOptions: Apollo.QueryHookOptions<MyPaymentCartQuery, MyPaymentCartQueryVariables> & ({ variables: MyPaymentCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPaymentCartQuery, MyPaymentCartQueryVariables>(MyPaymentCartDocument, options);
      }
export function useMyPaymentCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPaymentCartQuery, MyPaymentCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPaymentCartQuery, MyPaymentCartQueryVariables>(MyPaymentCartDocument, options);
        }
export function useMyPaymentCartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyPaymentCartQuery, MyPaymentCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPaymentCartQuery, MyPaymentCartQueryVariables>(MyPaymentCartDocument, options);
        }
export type MyPaymentCartQueryHookResult = ReturnType<typeof useMyPaymentCartQuery>;
export type MyPaymentCartLazyQueryHookResult = ReturnType<typeof useMyPaymentCartLazyQuery>;
export type MyPaymentCartSuspenseQueryHookResult = ReturnType<typeof useMyPaymentCartSuspenseQuery>;
export type MyPaymentCartQueryResult = Apollo.QueryResult<MyPaymentCartQuery, MyPaymentCartQueryVariables>;
export const MyPaidCartDocument = gql`
    query MyPaidCart($ordersInput: OrdersInput!) {
  myPaidCart(ordersInput: $ordersInput) {
    id
    invoiceId
    closed
    activated
    orderSteps
    sponsor {
      id
    }
    sponsorId
    userId
    totalAmount
    currency
    billingSource
    createdAt
    carts {
      id
      contentId
      promoId
      closed
      activated
      isPromo
      totalAmount
      invoiceId
      currency
      sponsor {
        id
        sponsorName
        companyName
      }
      sponsorId
      userId
      orders {
        id
      }
      bucketFund {
        id
        contentName
        currency
        specifiedArea
        amount
        frequency
        isPromoted
        orderType
      }
      promoBucket {
        id
        AddName
        currency
        specifiedArea
        amount
        orderType
        frequency
        isPromoted
      }
      events {
        id
        title
        currency
        bandaCode
        orderType
        amount
        frequency
        isPromoted
      }
      promoEvents {
        id
        title
        currency
        bandaCode
        orderType
        frequency
        isPromoted
        amount
      }
      createdAt
    }
  }
}
    `;

/**
 * __useMyPaidCartQuery__
 *
 * To run a query within a React component, call `useMyPaidCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPaidCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPaidCartQuery({
 *   variables: {
 *      ordersInput: // value for 'ordersInput'
 *   },
 * });
 */
export function useMyPaidCartQuery(baseOptions: Apollo.QueryHookOptions<MyPaidCartQuery, MyPaidCartQueryVariables> & ({ variables: MyPaidCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPaidCartQuery, MyPaidCartQueryVariables>(MyPaidCartDocument, options);
      }
export function useMyPaidCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPaidCartQuery, MyPaidCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPaidCartQuery, MyPaidCartQueryVariables>(MyPaidCartDocument, options);
        }
export function useMyPaidCartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyPaidCartQuery, MyPaidCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPaidCartQuery, MyPaidCartQueryVariables>(MyPaidCartDocument, options);
        }
export type MyPaidCartQueryHookResult = ReturnType<typeof useMyPaidCartQuery>;
export type MyPaidCartLazyQueryHookResult = ReturnType<typeof useMyPaidCartLazyQuery>;
export type MyPaidCartSuspenseQueryHookResult = ReturnType<typeof useMyPaidCartSuspenseQuery>;
export type MyPaidCartQueryResult = Apollo.QueryResult<MyPaidCartQuery, MyPaidCartQueryVariables>;
export const RegistrationDocument = gql`
    mutation Registration($registerInput: RegisterInput!) {
  registration(registerInput: $registerInput) {
    log
    message
  }
}
    `;
export type RegistrationMutationFn = Apollo.MutationFunction<RegistrationMutation, RegistrationMutationVariables>;

/**
 * __useRegistrationMutation__
 *
 * To run a mutation, you first call `useRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrationMutation, { data, loading, error }] = useRegistrationMutation({
 *   variables: {
 *      registerInput: // value for 'registerInput'
 *   },
 * });
 */
export function useRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<RegistrationMutation, RegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegistrationMutation, RegistrationMutationVariables>(RegistrationDocument, options);
      }
export type RegistrationMutationHookResult = ReturnType<typeof useRegistrationMutation>;
export type RegistrationMutationResult = Apollo.MutationResult<RegistrationMutation>;
export type RegistrationMutationOptions = Apollo.BaseMutationOptions<RegistrationMutation, RegistrationMutationVariables>;
export const RegistrationBandaDocument = gql`
    mutation RegistrationBanda($registerBandaInput: RegisterBandaInput!) {
  registrationBanda(registerBandaInput: $registerBandaInput) {
    log
    mode
  }
}
    `;
export type RegistrationBandaMutationFn = Apollo.MutationFunction<RegistrationBandaMutation, RegistrationBandaMutationVariables>;

/**
 * __useRegistrationBandaMutation__
 *
 * To run a mutation, you first call `useRegistrationBandaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrationBandaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrationBandaMutation, { data, loading, error }] = useRegistrationBandaMutation({
 *   variables: {
 *      registerBandaInput: // value for 'registerBandaInput'
 *   },
 * });
 */
export function useRegistrationBandaMutation(baseOptions?: Apollo.MutationHookOptions<RegistrationBandaMutation, RegistrationBandaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegistrationBandaMutation, RegistrationBandaMutationVariables>(RegistrationBandaDocument, options);
      }
export type RegistrationBandaMutationHookResult = ReturnType<typeof useRegistrationBandaMutation>;
export type RegistrationBandaMutationResult = Apollo.MutationResult<RegistrationBandaMutation>;
export type RegistrationBandaMutationOptions = Apollo.BaseMutationOptions<RegistrationBandaMutation, RegistrationBandaMutationVariables>;
export const RegistrationContentOwnerDocument = gql`
    mutation RegistrationContentOwner($registerContentInput: RegisterContentInput!) {
  registrationContentOwner(registerContentInput: $registerContentInput) {
    log
    mode
  }
}
    `;
export type RegistrationContentOwnerMutationFn = Apollo.MutationFunction<RegistrationContentOwnerMutation, RegistrationContentOwnerMutationVariables>;

/**
 * __useRegistrationContentOwnerMutation__
 *
 * To run a mutation, you first call `useRegistrationContentOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrationContentOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrationContentOwnerMutation, { data, loading, error }] = useRegistrationContentOwnerMutation({
 *   variables: {
 *      registerContentInput: // value for 'registerContentInput'
 *   },
 * });
 */
export function useRegistrationContentOwnerMutation(baseOptions?: Apollo.MutationHookOptions<RegistrationContentOwnerMutation, RegistrationContentOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegistrationContentOwnerMutation, RegistrationContentOwnerMutationVariables>(RegistrationContentOwnerDocument, options);
      }
export type RegistrationContentOwnerMutationHookResult = ReturnType<typeof useRegistrationContentOwnerMutation>;
export type RegistrationContentOwnerMutationResult = Apollo.MutationResult<RegistrationContentOwnerMutation>;
export type RegistrationContentOwnerMutationOptions = Apollo.BaseMutationOptions<RegistrationContentOwnerMutation, RegistrationContentOwnerMutationVariables>;
export const RegistrationSponsorDocument = gql`
    mutation RegistrationSponsor($registerSponsorInput: RegisterSponsorInput!) {
  registrationSponsor(registerSponsorInput: $registerSponsorInput) {
    log
    mode
  }
}
    `;
export type RegistrationSponsorMutationFn = Apollo.MutationFunction<RegistrationSponsorMutation, RegistrationSponsorMutationVariables>;

/**
 * __useRegistrationSponsorMutation__
 *
 * To run a mutation, you first call `useRegistrationSponsorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrationSponsorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrationSponsorMutation, { data, loading, error }] = useRegistrationSponsorMutation({
 *   variables: {
 *      registerSponsorInput: // value for 'registerSponsorInput'
 *   },
 * });
 */
export function useRegistrationSponsorMutation(baseOptions?: Apollo.MutationHookOptions<RegistrationSponsorMutation, RegistrationSponsorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegistrationSponsorMutation, RegistrationSponsorMutationVariables>(RegistrationSponsorDocument, options);
      }
export type RegistrationSponsorMutationHookResult = ReturnType<typeof useRegistrationSponsorMutation>;
export type RegistrationSponsorMutationResult = Apollo.MutationResult<RegistrationSponsorMutation>;
export type RegistrationSponsorMutationOptions = Apollo.BaseMutationOptions<RegistrationSponsorMutation, RegistrationSponsorMutationVariables>;
export const RemoveBandaGalleryImageDocument = gql`
    mutation RemoveBandaGalleryImage($imageInput: ImageInput!) {
  removeBandaGalleryImage(imageInput: $imageInput) {
    message
    status
  }
}
    `;
export type RemoveBandaGalleryImageMutationFn = Apollo.MutationFunction<RemoveBandaGalleryImageMutation, RemoveBandaGalleryImageMutationVariables>;

/**
 * __useRemoveBandaGalleryImageMutation__
 *
 * To run a mutation, you first call `useRemoveBandaGalleryImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBandaGalleryImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBandaGalleryImageMutation, { data, loading, error }] = useRemoveBandaGalleryImageMutation({
 *   variables: {
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useRemoveBandaGalleryImageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBandaGalleryImageMutation, RemoveBandaGalleryImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBandaGalleryImageMutation, RemoveBandaGalleryImageMutationVariables>(RemoveBandaGalleryImageDocument, options);
      }
export type RemoveBandaGalleryImageMutationHookResult = ReturnType<typeof useRemoveBandaGalleryImageMutation>;
export type RemoveBandaGalleryImageMutationResult = Apollo.MutationResult<RemoveBandaGalleryImageMutation>;
export type RemoveBandaGalleryImageMutationOptions = Apollo.BaseMutationOptions<RemoveBandaGalleryImageMutation, RemoveBandaGalleryImageMutationVariables>;
export const RemoveContentDocument = gql`
    mutation RemoveContent($deleteEvent: DeleteEvent!) {
  removeContent(deleteEvent: $deleteEvent) {
    message
    status
  }
}
    `;
export type RemoveContentMutationFn = Apollo.MutationFunction<RemoveContentMutation, RemoveContentMutationVariables>;

/**
 * __useRemoveContentMutation__
 *
 * To run a mutation, you first call `useRemoveContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContentMutation, { data, loading, error }] = useRemoveContentMutation({
 *   variables: {
 *      deleteEvent: // value for 'deleteEvent'
 *   },
 * });
 */
export function useRemoveContentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContentMutation, RemoveContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContentMutation, RemoveContentMutationVariables>(RemoveContentDocument, options);
      }
export type RemoveContentMutationHookResult = ReturnType<typeof useRemoveContentMutation>;
export type RemoveContentMutationResult = Apollo.MutationResult<RemoveContentMutation>;
export type RemoveContentMutationOptions = Apollo.BaseMutationOptions<RemoveContentMutation, RemoveContentMutationVariables>;
export const RemoveEventDocument = gql`
    mutation RemoveEvent($deleteEvent: DeleteEvent!) {
  removeEvent(deleteEvent: $deleteEvent) {
    message
    status
  }
}
    `;
export type RemoveEventMutationFn = Apollo.MutationFunction<RemoveEventMutation, RemoveEventMutationVariables>;

/**
 * __useRemoveEventMutation__
 *
 * To run a mutation, you first call `useRemoveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventMutation, { data, loading, error }] = useRemoveEventMutation({
 *   variables: {
 *      deleteEvent: // value for 'deleteEvent'
 *   },
 * });
 */
export function useRemoveEventMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventMutation, RemoveEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventMutation, RemoveEventMutationVariables>(RemoveEventDocument, options);
      }
export type RemoveEventMutationHookResult = ReturnType<typeof useRemoveEventMutation>;
export type RemoveEventMutationResult = Apollo.MutationResult<RemoveEventMutation>;
export type RemoveEventMutationOptions = Apollo.BaseMutationOptions<RemoveEventMutation, RemoveEventMutationVariables>;
export const RemoveSponsorGalleryImageDocument = gql`
    mutation RemoveSponsorGalleryImage($imageInput: ImageInput!) {
  removeSponsorGalleryImage(imageInput: $imageInput) {
    message
    status
  }
}
    `;
export type RemoveSponsorGalleryImageMutationFn = Apollo.MutationFunction<RemoveSponsorGalleryImageMutation, RemoveSponsorGalleryImageMutationVariables>;

/**
 * __useRemoveSponsorGalleryImageMutation__
 *
 * To run a mutation, you first call `useRemoveSponsorGalleryImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSponsorGalleryImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSponsorGalleryImageMutation, { data, loading, error }] = useRemoveSponsorGalleryImageMutation({
 *   variables: {
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useRemoveSponsorGalleryImageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSponsorGalleryImageMutation, RemoveSponsorGalleryImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSponsorGalleryImageMutation, RemoveSponsorGalleryImageMutationVariables>(RemoveSponsorGalleryImageDocument, options);
      }
export type RemoveSponsorGalleryImageMutationHookResult = ReturnType<typeof useRemoveSponsorGalleryImageMutation>;
export type RemoveSponsorGalleryImageMutationResult = Apollo.MutationResult<RemoveSponsorGalleryImageMutation>;
export type RemoveSponsorGalleryImageMutationOptions = Apollo.BaseMutationOptions<RemoveSponsorGalleryImageMutation, RemoveSponsorGalleryImageMutationVariables>;
export const SponsorDocument = gql`
    query Sponsor($getSponsorProfileInput: GetSponsorProfileInput!) {
  sponsor(getSponsorProfileInput: $getSponsorProfileInput) {
    id
    sponsorName
    companyName
    phoneNumber
    bio
    email
    address
    contentOwnership
    socialLinks
    backgroundImage
    physicalResidency
    userNationalId
    companyID
    otherProfileLinks
    cartItem {
      id
      contentId
      promoId
      isPromo
      closed
      activated
      itemName
      totalAmount
      currency
      orderSteps
      sponsor {
        id
        sponsorName
        companyName
        industry
        coverImage
        region
        district
        ward
        mtaa
      }
      sponsorId
      userId
      orders {
        id
      }
    }
    media
    coverImage
    verified
    isCompany
    anonymous
    industry
    region
    district
    ward
    mtaa
    blocked
    verifiedInt
    userId
    verifiedAt
    verifiedIntAt
    createdAt
  }
}
    `;

/**
 * __useSponsorQuery__
 *
 * To run a query within a React component, call `useSponsorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSponsorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsorQuery({
 *   variables: {
 *      getSponsorProfileInput: // value for 'getSponsorProfileInput'
 *   },
 * });
 */
export function useSponsorQuery(baseOptions: Apollo.QueryHookOptions<SponsorQuery, SponsorQueryVariables> & ({ variables: SponsorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SponsorQuery, SponsorQueryVariables>(SponsorDocument, options);
      }
export function useSponsorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SponsorQuery, SponsorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SponsorQuery, SponsorQueryVariables>(SponsorDocument, options);
        }
export function useSponsorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SponsorQuery, SponsorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SponsorQuery, SponsorQueryVariables>(SponsorDocument, options);
        }
export type SponsorQueryHookResult = ReturnType<typeof useSponsorQuery>;
export type SponsorLazyQueryHookResult = ReturnType<typeof useSponsorLazyQuery>;
export type SponsorSuspenseQueryHookResult = ReturnType<typeof useSponsorSuspenseQuery>;
export type SponsorQueryResult = Apollo.QueryResult<SponsorQuery, SponsorQueryVariables>;
export const SponsorDashboardDocument = gql`
    query SponsorDashboard($getSponsorProfileInput: GetSponsorProfileInput!) {
  sponsorDashboard(getSponsorProfileInput: $getSponsorProfileInput) {
    banda
    amount
    people
    content
    reservations
    adds
    createdAt
  }
}
    `;

/**
 * __useSponsorDashboardQuery__
 *
 * To run a query within a React component, call `useSponsorDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSponsorDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsorDashboardQuery({
 *   variables: {
 *      getSponsorProfileInput: // value for 'getSponsorProfileInput'
 *   },
 * });
 */
export function useSponsorDashboardQuery(baseOptions: Apollo.QueryHookOptions<SponsorDashboardQuery, SponsorDashboardQueryVariables> & ({ variables: SponsorDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SponsorDashboardQuery, SponsorDashboardQueryVariables>(SponsorDashboardDocument, options);
      }
export function useSponsorDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SponsorDashboardQuery, SponsorDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SponsorDashboardQuery, SponsorDashboardQueryVariables>(SponsorDashboardDocument, options);
        }
export function useSponsorDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SponsorDashboardQuery, SponsorDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SponsorDashboardQuery, SponsorDashboardQueryVariables>(SponsorDashboardDocument, options);
        }
export type SponsorDashboardQueryHookResult = ReturnType<typeof useSponsorDashboardQuery>;
export type SponsorDashboardLazyQueryHookResult = ReturnType<typeof useSponsorDashboardLazyQuery>;
export type SponsorDashboardSuspenseQueryHookResult = ReturnType<typeof useSponsorDashboardSuspenseQuery>;
export type SponsorDashboardQueryResult = Apollo.QueryResult<SponsorDashboardQuery, SponsorDashboardQueryVariables>;
export const SponsorGalleryDocument = gql`
    query SponsorGallery($feedInputData: FeedInputData!) {
  sponsorGallery(feedInputData: $feedInputData) {
    id
    description
    title
    media
    coverImage
    published
    authorSponsor {
      id
    }
    sponsorId
    userId
    event {
      id
    }
    eventId
    content {
      id
    }
    contentId
    bandaId
    createdAt
  }
}
    `;

/**
 * __useSponsorGalleryQuery__
 *
 * To run a query within a React component, call `useSponsorGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSponsorGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsorGalleryQuery({
 *   variables: {
 *      feedInputData: // value for 'feedInputData'
 *   },
 * });
 */
export function useSponsorGalleryQuery(baseOptions: Apollo.QueryHookOptions<SponsorGalleryQuery, SponsorGalleryQueryVariables> & ({ variables: SponsorGalleryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SponsorGalleryQuery, SponsorGalleryQueryVariables>(SponsorGalleryDocument, options);
      }
export function useSponsorGalleryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SponsorGalleryQuery, SponsorGalleryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SponsorGalleryQuery, SponsorGalleryQueryVariables>(SponsorGalleryDocument, options);
        }
export function useSponsorGallerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SponsorGalleryQuery, SponsorGalleryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SponsorGalleryQuery, SponsorGalleryQueryVariables>(SponsorGalleryDocument, options);
        }
export type SponsorGalleryQueryHookResult = ReturnType<typeof useSponsorGalleryQuery>;
export type SponsorGalleryLazyQueryHookResult = ReturnType<typeof useSponsorGalleryLazyQuery>;
export type SponsorGallerySuspenseQueryHookResult = ReturnType<typeof useSponsorGallerySuspenseQuery>;
export type SponsorGalleryQueryResult = Apollo.QueryResult<SponsorGalleryQuery, SponsorGalleryQueryVariables>;
export const SponsorOrdersDocument = gql`
    query SponsorOrders($getSponsorProfileInput: GetSponsorProfileInput!) {
  sponsorOrders(getSponsorProfileInput: $getSponsorProfileInput) {
    data
  }
}
    `;

/**
 * __useSponsorOrdersQuery__
 *
 * To run a query within a React component, call `useSponsorOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSponsorOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsorOrdersQuery({
 *   variables: {
 *      getSponsorProfileInput: // value for 'getSponsorProfileInput'
 *   },
 * });
 */
export function useSponsorOrdersQuery(baseOptions: Apollo.QueryHookOptions<SponsorOrdersQuery, SponsorOrdersQueryVariables> & ({ variables: SponsorOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SponsorOrdersQuery, SponsorOrdersQueryVariables>(SponsorOrdersDocument, options);
      }
export function useSponsorOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SponsorOrdersQuery, SponsorOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SponsorOrdersQuery, SponsorOrdersQueryVariables>(SponsorOrdersDocument, options);
        }
export function useSponsorOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SponsorOrdersQuery, SponsorOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SponsorOrdersQuery, SponsorOrdersQueryVariables>(SponsorOrdersDocument, options);
        }
export type SponsorOrdersQueryHookResult = ReturnType<typeof useSponsorOrdersQuery>;
export type SponsorOrdersLazyQueryHookResult = ReturnType<typeof useSponsorOrdersLazyQuery>;
export type SponsorOrdersSuspenseQueryHookResult = ReturnType<typeof useSponsorOrdersSuspenseQuery>;
export type SponsorOrdersQueryResult = Apollo.QueryResult<SponsorOrdersQuery, SponsorOrdersQueryVariables>;
export const SponsorsDocument = gql`
    query Sponsors($getSponsorsInput: GetSponsorsInput!) {
  sponsors(getSponsorsInput: $getSponsorsInput) {
    count
    list {
      id
      sponsorName
      companyName
      phoneNumber
      bio
      email
      address
      region
      district
      industry
      ward
      physicalResidency
      userNationalId
      companyID
      otherProfileLinks
      coverImage
      media
      verified
      anonymous
      blocked
      verifiedInt
      userId
      verifiedAt
      verifiedIntAt
      createdAt
    }
  }
}
    `;

/**
 * __useSponsorsQuery__
 *
 * To run a query within a React component, call `useSponsorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSponsorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsorsQuery({
 *   variables: {
 *      getSponsorsInput: // value for 'getSponsorsInput'
 *   },
 * });
 */
export function useSponsorsQuery(baseOptions: Apollo.QueryHookOptions<SponsorsQuery, SponsorsQueryVariables> & ({ variables: SponsorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SponsorsQuery, SponsorsQueryVariables>(SponsorsDocument, options);
      }
export function useSponsorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SponsorsQuery, SponsorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SponsorsQuery, SponsorsQueryVariables>(SponsorsDocument, options);
        }
export function useSponsorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SponsorsQuery, SponsorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SponsorsQuery, SponsorsQueryVariables>(SponsorsDocument, options);
        }
export type SponsorsQueryHookResult = ReturnType<typeof useSponsorsQuery>;
export type SponsorsLazyQueryHookResult = ReturnType<typeof useSponsorsLazyQuery>;
export type SponsorsSuspenseQueryHookResult = ReturnType<typeof useSponsorsSuspenseQuery>;
export type SponsorsQueryResult = Apollo.QueryResult<SponsorsQuery, SponsorsQueryVariables>;
export const AddSponsorSocialLinksDocument = gql`
    mutation AddSponsorSocialLinks($editSponsorInput: EditSponsorInput!) {
  addSponsorSocialLinks(editSponsorInput: $editSponsorInput) {
    log
    message
  }
}
    `;
export type AddSponsorSocialLinksMutationFn = Apollo.MutationFunction<AddSponsorSocialLinksMutation, AddSponsorSocialLinksMutationVariables>;

/**
 * __useAddSponsorSocialLinksMutation__
 *
 * To run a mutation, you first call `useAddSponsorSocialLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSponsorSocialLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSponsorSocialLinksMutation, { data, loading, error }] = useAddSponsorSocialLinksMutation({
 *   variables: {
 *      editSponsorInput: // value for 'editSponsorInput'
 *   },
 * });
 */
export function useAddSponsorSocialLinksMutation(baseOptions?: Apollo.MutationHookOptions<AddSponsorSocialLinksMutation, AddSponsorSocialLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSponsorSocialLinksMutation, AddSponsorSocialLinksMutationVariables>(AddSponsorSocialLinksDocument, options);
      }
export type AddSponsorSocialLinksMutationHookResult = ReturnType<typeof useAddSponsorSocialLinksMutation>;
export type AddSponsorSocialLinksMutationResult = Apollo.MutationResult<AddSponsorSocialLinksMutation>;
export type AddSponsorSocialLinksMutationOptions = Apollo.BaseMutationOptions<AddSponsorSocialLinksMutation, AddSponsorSocialLinksMutationVariables>;
export const EditSponsorDataDocument = gql`
    mutation EditSponsorData($editSponsorInput: EditSponsorInput!) {
  editSponsorData(editSponsorInput: $editSponsorInput) {
    log
    message
  }
}
    `;
export type EditSponsorDataMutationFn = Apollo.MutationFunction<EditSponsorDataMutation, EditSponsorDataMutationVariables>;

/**
 * __useEditSponsorDataMutation__
 *
 * To run a mutation, you first call `useEditSponsorDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSponsorDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSponsorDataMutation, { data, loading, error }] = useEditSponsorDataMutation({
 *   variables: {
 *      editSponsorInput: // value for 'editSponsorInput'
 *   },
 * });
 */
export function useEditSponsorDataMutation(baseOptions?: Apollo.MutationHookOptions<EditSponsorDataMutation, EditSponsorDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSponsorDataMutation, EditSponsorDataMutationVariables>(EditSponsorDataDocument, options);
      }
export type EditSponsorDataMutationHookResult = ReturnType<typeof useEditSponsorDataMutation>;
export type EditSponsorDataMutationResult = Apollo.MutationResult<EditSponsorDataMutation>;
export type EditSponsorDataMutationOptions = Apollo.BaseMutationOptions<EditSponsorDataMutation, EditSponsorDataMutationVariables>;
export const CreateContentDocument = gql`
    mutation CreateContent($createContentInput: CreateContentInput!) {
  createContent(createContentInput: $createContentInput) {
    status
    message
  }
}
    `;
export type CreateContentMutationFn = Apollo.MutationFunction<CreateContentMutation, CreateContentMutationVariables>;

/**
 * __useCreateContentMutation__
 *
 * To run a mutation, you first call `useCreateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentMutation, { data, loading, error }] = useCreateContentMutation({
 *   variables: {
 *      createContentInput: // value for 'createContentInput'
 *   },
 * });
 */
export function useCreateContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentMutation, CreateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentMutation, CreateContentMutationVariables>(CreateContentDocument, options);
      }
export type CreateContentMutationHookResult = ReturnType<typeof useCreateContentMutation>;
export type CreateContentMutationResult = Apollo.MutationResult<CreateContentMutation>;
export type CreateContentMutationOptions = Apollo.BaseMutationOptions<CreateContentMutation, CreateContentMutationVariables>;
export const UserDocument = gql`
    query User($getUserProfileInput: GetUserProfileInput!) {
  user(getUserProfileInput: $getUserProfileInput) {
    id
    username
    email
    phoneNumber
    fullName
    coverImage
    isContentOwner
    isBandaUmiza
    userNationalId
    address
    physicalResidency
    createdAt
    accountFeedBacks
    verified
    disabled
    bandaUmizaList {
      bandaName
      ownerName
      description
      phoneNumber
      email
      bandaCode
      media
      location
      address
      userNationalId
      capacity
      numberOfTv
      physicalResidency
      verified
      blocked
      userId
      createdAt
    }
    contents {
      id
      title
      coverImage
      fundedBy
      createdAt
      published
      languages
      categories {
        name
      }
    }
    sponsor {
      id
      userNationalId
      verified
      blocked
    }
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      getUserProfileInput: // value for 'getUserProfileInput'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;